/// <reference path="../../../../../rcwebmodels/vesselstatus.cs.d.ts" />
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as VesselStatusState from '../../store/VesselStatus';
import * as UserDetailState from '../../store/UserDetails';
import { AgGridReact } from 'ag-grid-react';
import Formatters from '../../actions/Formatters';
import ReeferFormatters from '../../actions/ReeferFormatter';
import { ReeferCellRenderer } from '../../actions/ReeferCellRenderer'; //RCNG 146
import $ from 'jquery';
// pull in the ag-grid styles we're interested in
import './../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import './../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import './../../../node_modules/react-toggle-switch/dist/css/switch.min.css';
import { VesselSearch } from '../childcomponents/VesselSearch';
import { RCUtils } from './../../RCUtils';
import { SendEmailControl } from './../sharedcomponents/SendEmailControl';
import { EmailControlExcel } from './../sharedcomponents/EmailControlExcel';
import { PingControl } from './../sharedcomponents/ForwardCommands/PingControl';
import { TempSetPoint } from './../sharedcomponents/ForwardCommands/TempSetPoint';
import { HumiditySetPoint } from './../sharedcomponents/ForwardCommands/HumiditySetPoint';
import { O2SetPoint } from './../sharedcomponents/ForwardCommands/O2SetPoint';
import { CO2SetPoint } from './../sharedcomponents/ForwardCommands/CO2SetPoint';
import { ChangeReeferId } from './../sharedcomponents/ForwardCommands/ChangeReeferId';
import { ChangeReportingInterval } from './../sharedcomponents/ForwardCommands/ChangeReportingInterval';
import { ChangeDataLogInterval } from './../sharedcomponents/ForwardCommands/ChangeDataLogInterval';
import { TraditionalDataDownload } from './../sharedcomponents/ForwardCommands/TraditionalDataDownload';
import { PreTrip } from './../sharedcomponents/ForwardCommands/PreTrip';
import { StopPTI } from './../sharedcomponents/ForwardCommands/StopPTI';
import { ScheduledPreTrip } from './../sharedcomponents/ForwardCommands/ScheduledPreTrip';
import { LastPretripResult } from './../sharedcomponents/ForwardCommands/LastPretripResult';
import { RebootReeferController } from './../sharedcomponents/ForwardCommands/RebootReeferController';
import { QueryReeferInventory } from './../sharedcomponents/ForwardCommands/QueryReeferInventory';
import { UpdateModelConfiguration } from './../sharedcomponents/ForwardCommands/UpdateModelConfiguration';
import { VerifyModelValidity } from './../sharedcomponents/ForwardCommands/VerifyModelValidity';
import { SyncReeferClock } from './../sharedcomponents/ForwardCommands/SyncReeferClock';
import { StartDeforst } from './../sharedcomponents/ForwardCommands/StartDeforst';
import { ChangeDeforstInterval } from './../sharedcomponents/ForwardCommands/ChangeDeforstInterval';
import { AssignToCustomer } from '../childcomponents/AssignToCustomer';
import { UnassignReefersFromCustomer } from '../childcomponents/UnassignReefersFromCustomer';
import { AssignPANID } from './../sharedcomponents/ForwardCommands/AssignPANID';
import { ChangeReeferClockSyncSetting } from './../sharedcomponents/ForwardCommands/ChangeReeferClockSyncSettings';
import { GuestReeferConfiguration } from './../sharedcomponents/ForwardCommands/GuestReeferConfiguration';
import { AutoConfiguration } from './../sharedcomponents/ForwardCommands/AutoConfiguration';
import { AssetConfiguration } from './../sharedcomponents/ForwardCommands/AssetConfiguration';
import { MultipleSetpoints } from './../sharedcomponents/ForwardCommands/MultipleSetpoints';
import { AutomaticColdTreatment } from './../sharedcomponents/ForwardCommands/AutomaticColdTreatment';
import { GetFreshAirType } from './../sharedcomponents/ForwardCommands/GetFreshAirType';
import { SetFreshAirType } from './../sharedcomponents/ForwardCommands/SetFreshAirType';
import { GridToolBarControl } from './../sharedcomponents/GridToolBarControl';
import { ChangeZigbeeSettings } from './../sharedcomponents/ForwardCommands/ChangeZigbeeSettings';
import { ControlledAtmosphere } from './../sharedcomponents/ForwardCommands/ControlledAtmosphere';
import { DeviceReset } from './../sharedcomponents/ForwardCommands/DeviceReset';
import { DeviceHardReset } from './../sharedcomponents/ForwardCommands/DeviceReset';
import { TripWiseReport } from './../sharedcomponents/ForwardCommands/TripWiseReport';
import forEach from 'lodash/forEach';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import UserRights from '../../actions/UserRights';
import CommonActions from '../../actions/CommonActions';
import * as Exceljs from '../../actions/ExportToExcel.js';
import ExportAction from '../../actions/ExportAction'
var Excel = Exceljs.default;
var Config: any = require('../../Config.json');

var vesselColumns;
var vesselStatus;
var self;
var customerTypeCd;
var custId;
var userEmail;

var voyageList: any[];
var coppiedData;
var coppiedDataWithHeader;
// At runtime, Redux will merge together...
type VesselStatusProps =
    UserDetailState.UserState
    & VesselStatusState.VesselSearchState       // ... state we've requested from the Redux store     
    & typeof VesselStatusState.actionCreators      // ... plus action creators we've requested
    & RouteComponentProps<{}>; // ... plus incoming routing parameters

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface VesselSearchState {
    selectedItems: any[];
    isChangeDeforstInterval: boolean;
    preTripCmd: string;
    modelTitle: string;
    popUpHtml: any;
    pageSize: any;
    gridApiParams: any;
    exportFields: ExportFields;
    VCCheckBoxInfo: VCCheckBoxData;
    PTReport: string;
    ReportReeferId: string;
    isStarCoolOem: boolean;
    gridData: server.USP_UnitCurrentConditionUI_Model[];
    vesselData: server.VesselEntityCollection;
    CustomerSpecificCommandData: any;
    fullPreTripCommandText: string;
    shortPreTripCommandText: string;
    funcPreTripCommandText: string;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];

    voyageList: any[];

    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
}
class ExportFields {
    ExportData: string;
}


class VesselStatus extends React.Component<VesselStatusProps, VesselSearchState> {
    constructor(props: any) {
        super(props);
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;//this.props.loggedInUserData.User.Customer.CustomerTypeCd;
        custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;//this.props.loggedInUserData.User.Customer.CustomerId;
        userEmail = JSON.parse(sessionStorage.getItem('UserInfo')).UserEmail;
        var exportData = new ExportFields();
        var emptyVesselData = { VesselIDList: [], VoyageIDList: [], PortOfDepartureList: [], PortOfDestinationList: [] };
        var commandSpecificData: server.CommandSpecificData = { commandId: '', Oem: [] };
        this.state = {
            selectedItems: [], isChangeDeforstInterval: false, preTripCmd: '', modelTitle: '', popUpHtml: '',
            pageSize: 25,
            gridApiParams: [],
            exportFields: exportData,
            VCCheckBoxInfo: emptyVCCheckBoxData,
            PTReport: '',
            ReportReeferId: '',
            isStarCoolOem: false,
            gridData: [],
            vesselData: emptyVesselData,
            CustomerSpecificCommandData: commandSpecificData,
            fullPreTripCommandText: 'Full', shortPreTripCommandText: 'Short', funcPreTripCommandText: 'Function Test',
            IsCommandIssued: false,
            PrevSelectedItems: [],
            voyageList: [],
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            autoGroupColumnDef: { minWidth: 200 },
        };

        this.props.requestEventMaster();
        vesselColumns = this.createColumnDefs();
        this.props.requestVesselData(vesselColumns);
        self = this;
    }

    onGridReady(params: any) {
        //params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
    }

    onCellClickedCopy(event) {
        //coppiedDataWithHeader = event.colDef.headerName + " \r\n" + event.value;
        //coppiedData = event.value;

        if (event.data != null && event.data != undefined) {
            //self.props.getLastSelectedRow(event.data);
            //$('#globalLoader').show();
            if (event.colDef.headerName === "Comments" && event.value === 0)
                this.reeferdetailsAction(this.state.selectedItems, 'Reefer', 'Comments');
        }
    }

    italicizeGridRows(params: any) {
        if (params.data != null && params.data != undefined) {
            if (params.data.EventDTTM != params.data.UnitEventDTTM)
                return { 'font-style': 'italic' }
        }
    }
    /*
    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: '',
                children: [
                    { headerName: "CC", field: "CCSeverityLevel", valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellClass: 'bigInt', cellRenderer: ReeferFormatters.CargoCareFormatter, pinned: true, width: 65 },
                    { headerName: "ALM", field: "MASeverityLevel", cellClass: 'bigInt', cellRenderer: (params) => { return ReeferFormatters.statusIndicatorWithDescriptionForALM(params, self.props.reeferFormatter.AlarmMasterList); }, pinned: true, width: 65 },
                    { headerName: "RUN", field: "RunState", valueGetter: (params) => { return ReeferFormatters.RunstateSorting(params); }, cellClass: 'bigInt', cellRenderer: Formatters.runStateFormatter, pinned: true, width: 65 },
                    { headerName: "PWR", field: "DevicePowerSourceCd", valueGetter: (params) => { return Formatters.PwrSorting(params); }, cellClass: 'bigInt', cellRenderer: Formatters.pwrStateFormatter, pinned: true, width: 65 },
                    { headerName: "VSL", field: "VesselCd", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, pinned: true, width: 80 },
                    { headerName: "OEM", field: "ReeferOEMTypeCd", cellClass: 'bigInt', cellRenderer: Formatters.oemTypeFormatter, pinned: true, width: 70 },
                    { headerName: "Reefer ID", field: "ReeferID", pinned: true, cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Vessel ID", field: "VesselID", pinned: true, cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 100 },
                    { headerName: "Voyage ID", field: "VoyageID", pinned: true, cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 100 },
                    { headerName: "Departure port", field: "PortOfDeparture", pinned: true, cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 120 },
                    { headerName: "Destination port", field: "PortOfDestination", pinned: true, cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 }
                ],
                pinned: true
            },
            {
                headerName: 'Latest Event, Last Reported Reefer and Device data',
                children: [
                    { headerName: "Event", field: "EventDescription", cellClass: 'bigInt', valueGetter: (params) => { return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList, self.props.reeferFormatter.EventMasterList); }, cellRenderer: (params) => { return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList, self.props.reeferFormatter.EventMasterList); }, width: 150 },
                    { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellClass: 'bigInt', cellRenderer: Formatters.dateTypeFormatter, width: 150 },                    
                 -{ headerName: "Reefer data", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "UnitEventDTTM", cellClass: 'bigInt', cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "Alarm", field: "AlarmsList", cellClass: 'bigInt', cellRenderer: (params) => { return ReeferFormatters.AlarmDescriptionFormatter(params, self.props.reeferFormatter.AlarmMasterList); }, width: 150 },
                    { headerName: "Opr.Mode", field: "RunningMode", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Cmd P", field: "PendingCommands", cellClass: 'bigInt', cellRenderer: Formatters.commandTypeFormatter, width: 60 },
                    { headerName: "Cmd A", field: "ActiveCommands", cellClass: 'bigInt', cellRenderer: Formatters.commandTypeFormatter, width: 60 },
                    { headerName: "Cmd E", field: "ErrorCommands", cellClass: 'bigInt', cellRenderer: Formatters.commandTypeFormatter, width: 60 },
                    { headerName: "T set ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "SetPoint", width: 90 },
                    { headerName: "T sup 1 ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "SupplyTemp1", width: 90 },
                    { headerName: "T sup 2 ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "SupplyTemp2", width: 90 },
                    { headerName: "T rtn 1 ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "ReturnTemp1", width: 90 },
                    { headerName: "T rtn 2 ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "ReturnTemp2", width: 90 },
                    { headerName: "T amb ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "AmbientTemp", width: 90 },                    
                    { headerName: "RH set", field: "HumiditySetpoint", cellClass: 'bigInt', cellRenderer: ReeferFormatters.HumiditySetpointFormatter, width: 90 },
                    { headerName: "RH read", field: "Humidity", cellClass: 'bigInt', cellRenderer: ReeferFormatters.HumiditySettingFormatter, width: 90 },
                    { headerName: "CO2 set", field: "CO2Setpoint", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "CO2 read", field: "CO2Reading", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "O2 set", field: "O2Setpoint", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "O2 read", field: "O2Reading", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "T evap wall ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "EvaporatorTemp", width: 110 },
                    { headerName: "P suc", field: "CompositeSuctionPressure", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "T Suc ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "CompressorSuctionTemp", width: 90 },
                    { headerName: "P dis", field: "DischargePressure", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "T dis ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "CompressorDischargeTemp", width: 90 },
                    { headerName: "P cond", field: "CondenserPressure", cellClass: 'bigInt', cellRenderer: ReeferFormatters.sensorDataPCondFormatter, width: 90 },
                    { headerName: "T cond wall ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "CondenserTemperature", width: 110 },
                    { headerName: "M cond", field: "CondenserFanOutPut", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "LS evap", field: "LowSpeedEvaporatorFanOutPut", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "HS evap", field: "HighSpeedEvaporatorFanOutPut", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Heat on", field: "HeaterOnTime", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Open exp", field: "EvaporatorExpansionValveOpening", cellClass: 'bigInt', cellRenderer: ReeferFormatters.sensorDataOpenExpFormatter, width: 90 },
                    { headerName: "Open suc", field: "SuctionModulationValveOpening", cellClass: 'bigInt', cellRenderer: ReeferFormatters.sensorDataOpenSucFormatter, width: 90 },
                    { headerName: "Open dis", field: "HotGasValveOpening", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Open econ", field: "EconomizerValveOpening", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Comp freq", field: "CompressorFrequency", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "USDA 1 ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "USDA1Temp", width: 90 },
                    { headerName: "USDA 2 ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "USDA2Temp", width: 90 },
                    { headerName: "USDA 3 ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "USDA3Temp", width: 90 },
                    { headerName: "USDA 4 cargo ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "Cargo4Temp", width: 130 },
                    { headerName: "Vent pos", field: "VentPositionSensorCMH", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Atm. mode", field: "ControlledAtmosphereMode", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "PTI state", field: "PTIState", cellClass: 'bigInt', valueGetter: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.props.reeferFormatter.PreTripList); }, cellRenderer: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.props.reeferFormatter.PreTripList); }, width: 100 },
                    { headerName: "PTI result", field: "PTResult", tooltip: Formatters.toolTipFormatter, cellClass: 'bigInt', cellRenderer: ReeferFormatters.preTripFormatter, width: 100 },
                    { headerName: "PTI time", field: "PTRDateTime", headerValueGetter: Formatters.TimeZoneHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "Freq", field: "LineFrequency", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 100 },
                    { headerName: "3 Ph. curr.", field: "ThreePhaseCurrent", cellClass: 'bigInt', cellRenderer: ReeferFormatters.Current3PhaseFormatter, width: 135 },
                    { headerName: "Tot curr.", field: "TotalCurrentDraw", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 100 },
                    { headerName: "Device supply (V)", field: "ReeferACPowerLevel", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 150 },
                    //{ headerName: "Device pwr source", field: "RCDPowerSourceCd", cellRenderer: Formatters.rcdPowerSourceFormatter, width: 150 },
                    { headerName: "GPS coords", field: "GPSCoords", cellClass: 'bigInt', valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, cellRenderer: Formatters.GPSCoordsFormatter, width: 150 },
                    { headerName: "Last GPS (h:m:s)", field: "GPSLastLock", cellClass: 'bigInt', cellRenderer: Formatters.secondsToTimeConverter, width: 150 },
                    { headerName: "MCC (country)", field: "CountryName", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "MNC", field: "MNC", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 70 },
                    { headerName: "LAC", field: "TowerLocalizationAreaCode", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 70 },
                    { headerName: "Tower ID", field: "TowerBaseStationID", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 130 },
                    { headerName: "Const s/n", field: "ControllerSerialNumber", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Cont SW version", field: "SoftwareRevision", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 120 },
                    { headerName: "Cont time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DataLoggerDtm", cellClass: 'bigInt', cellRenderer: Formatters.dateTypeFormatter, width: 120 },
                    { headerName: "Device ID", field: "RCDID", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Device FW ver", field: "RCDFirmwareVersion", cellClass: 'bigInt', valueGetter: (params) => { return ReeferFormatters.FirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MAIN'); }, cellRenderer: (params) => { return ReeferFormatters.FirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MAIN'); }, width: 130 },
                    { headerName: "Device BL ver", field: "RCDBootloaderVersion", cellClass: 'bigInt', valueGetter: (params) => { return ReeferFormatters.BootloaderFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'BL'); }, cellRenderer: (params) => { return ReeferFormatters.BootloaderFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'BL'); }, width: 130 },
                    { headerName: "Device mesh FW ver", field: "RCDMeshFirmwareVersion", cellClass: 'bigInt', valueGetter: (params) => { return ReeferFormatters.MeshFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MESH'); }, cellRenderer: (params) => { return ReeferFormatters.MeshFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MESH'); }, width: 150 },
                    { headerName: "Geofence revision", field: "RevisionNum", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Device temp ", headerValueGetter: Formatters.TempHeaderFormatter, cellClass: 'bigInt', cellRenderer: Formatters.TemperatureFormatter, field: "DeviceTemp", width: 130 },
                    { headerName: "Device bat (V)", field: "BatteryVoltage", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Cell gen", field: "CellNetGeneration", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 80 },
                    { headerName: "Cell signal", field: "RSSI", cellClass: 'bigInt', cellRenderer: Formatters.RSSITypeFormatter, width: 70 },
                    { headerName: "Receipt time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "ModifiedDTTM", cellClass: 'bigInt', cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "L1 (VAC)", field: "LineVoltage1", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "L2 (VAC)", field: "LineVoltage2", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "L3 (VAC)", field: "LineVoltage3", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "VFD", field: "VFD", cellClass: 'bigInt', cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Reporting (min)", field: "RCDReportingInterval", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 130 },
                    { headerName: "Assigned to", field: "CustomerName", cellClass: 'bigInt', valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSortingFor3P(params.data.CustomerName); },cellRenderer: Formatters.stringTypeFormatterFor3P, width: 150 },
                    { headerName: "Fresh air type", field: "FreshAirType", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 120 }
                ]
            }
        ];
    }
    */
    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: '',
                children: [
                    { headerName: "CC", field: "CCSeverityLevel", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return ReeferFormatters.CargoCareFormatterForFilter(params); } }, resizable: true, width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "ALM", field: "MASeverityLevel", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return ReeferFormatters.statusIndicatorWithDescriptionForALMForFilter(params) } }, valueGetter: (params) => { return ReeferFormatters.statusALMSorting(params); }, resizable: true, width: 65, cellRenderer: (params) => { return ReeferCellRenderer.StatusIndicatorWithDescriptionForAlarms(params, self.props.reeferFormatter.AlarmMasterList); }, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "RUN", field: "RunState", pinned: true, width: 65, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return ReeferFormatters.runStateFormatterForFilter(params); } }, resizable: true, valueGetter: (params) => { return ReeferFormatters.RunstateSorting(params); }, cellRenderer: ReeferCellRenderer.RunStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "PWR", field: "DevicePowerSourceCd", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.pwrStateFormatterForFilter(params); } }, resizable: true, width: 65, valueGetter: (params) => { return Formatters.PwrSorting(params); }, cellRenderer: ReeferCellRenderer.PwrStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "VSL", field: "VesselCd", cellClass: 'bigInt', sortable: true, filter: true, resizable: true, cellRenderer: Formatters.stringTypeFormatter, pinned: true, width: 80 },
                    { headerName: "VSL", field: "VesselCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "VesselCd"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "VSL", field: "VesselCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "VesselCd"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "OEM", field: "ReeferOEMTypeCd", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return ReeferFormatters.oemTypeFormatterForFilter(params); } }, resizable: true,
                        valueGetter: params => { return ReeferFormatters.OEMTypeValueFormatterFieldName(params); },
                        width: 70, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "Reefer ID", field: "ReeferID", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ReeferID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Vessel ID", field: "VesselID", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "VesselID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Voyage ID", field: "VoyageID", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "VoyageID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Departure port", field: "PortOfDeparture", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "PortOfDeparture"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Destination port", field: "PortOfDestination", pinned: true, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "PortOfDestination"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: "Booking",
                children: [
                    { headerName: "Booking #", field: "BookingNumber", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BookingNumber"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BK temp ", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "TemperatureUnit"); }, cellRenderer: ReeferFormatters.TemperatureFormatterForBooking, field: "TemperatureUnit", columnGroupShow: 'open', width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Assigned to", field: "CustomerName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSortingFor3P(params.data.CustomerName); }, filterParams: { valueGetter: params => { return Formatters.stringTypeFormatterFor3PForFilter(params); } }, cellRenderer: ReeferCellRenderer.StringTypeFormatterFor3P, width: 130, onCellClicked: this.onCellClickedCopy.bind(this), columnGroupShow: 'open' }
                ]
            },
            {
                headerName: 'Latest Event, Last Reported Reefer and Device data',
                children: [
                    {
                        headerName: "Event", field: "EventDescription", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        resizable: true, valueGetter: (params) => { return ReeferFormatters.EventDescriptionFormattersOld(params, self.props.reeferFormatter.CustomerSpecificEventList, self.props.reeferFormatter.EventMasterList); },
                        cellRenderer: (params) => { return ReeferFormatters.EventDescriptionFormattersOld(params, self.props.reeferFormatter.CustomerSpecificEventList, self.props.reeferFormatter.EventMasterList); }, width: 150,
                        enableTooltip: true, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "Event time", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterEventDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "EventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Device fence", field: "GeofenceName", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Device fence", field: "GeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "GeofenceName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Server fence", field: "ServerGeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ServerGeofenceName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Device fence ID", field: "Geofence", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Device fence ID", field: "Geofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Geofence"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Server fence ID", field: "ServerGeofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ServerGeofence"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    /*{ headerName: "City", field: "City", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 140 },
                    { headerName: "State", field: "State", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 140 },
                    { headerName: "Country", field: "Country", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Zip", field: "Zip", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 100 },*/
                    { headerName: "City", field: "City", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "City"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "State", field: "State", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "State"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Country", field: "Country", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Country"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Zip", field: "Zip", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Zip"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },

                    { headerName: "Reefer data", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterUnitEventDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "UnitEventDTTM", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "UnitEventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Alarm", field: "AlarmsList", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.AlarmDescriptionSorting(params, self.props.reeferFormatter.AlarmMasterList); }, cellRenderer: (params) => { return ReeferCellRenderer.AlarmsDescriptionFormatter(params, self.props.reeferFormatter.AlarmMasterList); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Opr .Mode", field: "RunningMode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.OperatingModeFormatter(params); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Cmd P", field: "PendingCommands", cellClass: 'myExcelStyle', resizable: true, cellRenderer: ReeferCellRenderer.CommandTypeFormatter, width: 60 },
                    { headerName: "Cmd A", field: "ActiveCommands", cellClass: 'myExcelStyle', resizable: true, cellRenderer: ReeferCellRenderer.CommandTypeFormatter, width: 60 },
                    { headerName: "Cmd E", field: "ErrorCommands", cellClass: 'myExcelStyle', resizable: true, cellRenderer: ReeferCellRenderer.CommandTypeFormatter, width: 60 },
                    { headerName: "T set ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SetPoint"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SetPoint", width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T sup 1 ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SupplyTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SupplyTemp1", width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T sup 2 ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SupplyTemp2"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SupplyTemp2", width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T rtn 1 ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "ReturnTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "ReturnTemp1", width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T rtn 2 ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "ReturnTemp2"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "ReturnTemp2", width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T amb. ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "AmbientTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "AmbientTemp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "RH set", field: "HumiditySetpoint", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HumiditySetpoint"); }, cellRenderer: ReeferFormatters.HumiditySetpointFormatter, getQuickFilterText: ReeferFormatters.HumiditySetpointFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "RH read", field: "Humidity", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.HumiditySettingFormatter(params); }, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "CO2 set", field: "CO2Setpoint", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CO2Setpoint"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "CO2 read", field: "CO2Reading", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CO2Reading"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "O2 set", field: "O2Setpoint", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "O2Setpoint"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "O2 read", field: "O2Reading", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "O2Reading"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T evap wall ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EvaporatorTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EvaporatorTemp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "P suc", field: "CompositeSuctionPressure", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CompositeSuctionPressure"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T suc", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CompressorSuctionTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CompressorSuctionTemp", width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "P dis", field: "DischargePressure", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "DischargePressure"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T dis ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CompressorDischargeTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CompressorDischargeTemp", width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "P cond", field: "CondenserPressure", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataPCondFormatter(params); }, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T cond wall ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CondenserTemperature"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CondenserTemperature", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "M cond", field: "CondenserFanOutPut", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CondenserFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "LS evap", field: "LowSpeedEvaporatorFanOutPut", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LowSpeedEvaporatorFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "HS evap", field: "HighSpeedEvaporatorFanOutPut", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HighSpeedEvaporatorFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Heat on", field: "HeaterOnTime", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HeaterOnTime"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Open exp", field: "EvaporatorExpansionValveOpening", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataOpenExpFormatter(params); }, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Open suc", field: "SuctionModulationValveOpening", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataOpenSucFormatter(params); }, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Open dis", field: "HotGasValveOpening", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HotGasValveOpening"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Open econ", field: "EconomizerValveOpening", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "EconomizerValveOpening"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Comp freq", field: "CompressorFrequency", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CompressorFrequency"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "USDA1 ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA1Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA1Temp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "USDA2 ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA2Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA2Temp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "USDA3 ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA3Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA3Temp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "USDA4 cargo ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "Cargo4Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "Cargo4Temp", width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Vent pos", field: "VentPositionSensorCMH", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "VentPositionSensorCMH"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Atm. mode", field: "ControlledAtmosphereMode", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.ControlledAtmosphereMode(params); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "PTI state", field: "PTIState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.props.reeferFormatter.PreTripList); }, cellRenderer: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.props.reeferFormatter.PreTripList); }, getQuickFilterText: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.props.reeferFormatter.PreTripList); }, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "PTI result", field: "PTResult", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, tooltip: Formatters.toolTipFormatter, valueGetter: (params) => { return ReeferFormatters.PTResultSorting(params); }, cellRenderer: ReeferCellRenderer.PreTripFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "PTI time", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "PTRDateTime", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "PTRDateTime"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Freq", field: "LineFrequency", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineFrequency"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "3 ph curr", field: "ThreePhaseCurrent", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.ThreePhaseCurrentSortingFieldName(params, "ThreePhaseCurrent"); }, cellRenderer: ReeferFormatters.Current3PhaseFormatter, width: 135, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Tot curr", field: "TotalCurrentDraw", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "TotalCurrentDraw"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Device supply (V)", field: "ReeferACPowerLevel", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "ReeferACPowerLevel"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc coords", field: "GPSCoords", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, filterParams: { valueGetter: params => { return Formatters.GPSCoordsForFilter(params); } }, cellRenderer: ReeferCellRenderer.GPSCoordsFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc age (h:m:s)", field: "GPSLastLock", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.reeferSecondsToTimeConverterFilter(params); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "MCC (country)", field: "CountryName", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "MCC (country)", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, field: "CountryName", valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CountryName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter,  width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "MNC", field: "MNC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.MNCSorting(params); }, cellRenderer: ReeferCellRenderer.MNCTypeFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "LAC", field: "TowerLocalizationAreaCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerLocalizationAreaCode"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Tower ID", field: "TowerBaseStationID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerBaseStationID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Cont s/n", field: "ControllerSerialNumber", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ControllerSerialNumber"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Cont SW version", field: "SoftwareRevision", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "SoftwareRevision"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Cont time", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DataLoggerDtm", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DataLoggerDtm"); }, cellRenderer: Formatters.dateTypeFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Device ID", field: "RCDID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device FW ver", field: "RCDFirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.FirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MAIN'); }, cellRenderer: (params) => { return ReeferFormatters.FirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MAIN'); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device BL ver", field: "RCDBootloaderVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.BootloaderFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'BL'); }, cellRenderer: (params) => { return ReeferFormatters.BootloaderFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'BL'); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device mesh FW ver", field: "RCDMeshFirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.MeshFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MESH'); }, cellRenderer: (params) => { return ReeferFormatters.MeshFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MESH'); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    // { headerName: "Geofence revision", field: "RevisionNum", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Geofence revision", field: "RevisionNum", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RevisionNum"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device temp ", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "DeviceTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "DeviceTemp", width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Device bat (V)", field: "BatteryVoltage", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { return Formatters.BattVoltageSortingFieldName(params, "BatteryVoltage"); },
                        filterParams: { valueGetter: params => { return Formatters.BatteryVoltageFormatterForFilter(params); } },
                        cellRenderer: Formatters.BattVoltageValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "Cell gen", field: "CellNetGeneration", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CellNetGeneration"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 80, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Cell signal", field: "RSSI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.RSSISorting(params); },
                        filterParams: { valueGetter: params => { return Formatters.RSSITypeFormatterFilter(params); } }, cellRenderer: ReeferCellRenderer.RSSITypeFormatter, width: 80, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "Receipt time", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterModifiedDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "ModifiedDTTM", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "ModifiedDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "L1 (VAC)", field: "LineVoltage1", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage1"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "L2 (VAC)", field: "LineVoltage2", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage2"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "L3 (VAC)", field: "LineVoltage3", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage3"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "EverFRESH", field: "EverFRESH", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EverFRESH"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "VFD", field: "VFD", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "VFD"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Reporting (min)", field: "RCDReportingInterval", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDReportingInterval"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    // { headerName: "Assigned to", field: "CustomerName", cellClass: 'bigInt', valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSortingFor3P(params.data.CustomerName); }, cellRenderer: Formatters.stringTypeFormatterFor3P, width: 150 },
                    { headerName: "Fresh air type", field: "FreshAirType", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FreshAirType"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) }
                ]
            }
        ]
    }


    componentWillReceiveProps(nextprops: any) {
        if (!nextprops.isLoading) {
            $('#globalLoader').hide();
            if (nextprops.vesselStatus != null && nextprops.vesselStatus != undefined) {
                this.setState({ gridData: nextprops.vesselStatus });
            }

            if (nextprops.vesselData != null && nextprops.vesselData != undefined) {
                this.setState({ vesselData: nextprops.vesselData });
            }

            if (nextprops.performCargoAction) {
                $('#globalLoader').show();
                this.props.requestVesselSearch(this.props.searchFilters, vesselColumns);
                if (self.state.gridApiParams != null && self.state.gridApiParams != []) {
                    self.state.gridApiParams.paginationGoToFirstPage();
                }
            }
        } else {
            $('#globalLoader').show();
        }
    }

    bindingVesselStatusGrid(searchState: any) {
        $('#globalLoader').show();
        this.props.requestVesselSearch(searchState, vesselColumns);
        if (self.state.gridApiParams != null && self.state.gridApiParams != []) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }
    }

    exportToExcel() {
        var arrData;
        if (self.state.selectedItems != null) {
            arrData = typeof self.state.selectedItems != 'object' ? JSON.parse(self.state.selectedItems) : self.state.selectedItems;
        }
        else {
            arrData = typeof this.props.vesselStatus != 'object' ? JSON.parse(this.props.vesselStatus) : this.props.vesselStatus;
        }
        $("#globalLoader").show();
        var r = this.props.columnDefs;
        try {
            //Excel.InitializeExcelExport(arrData, r, 'VesselStatusGrid');
            //PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            var formName = 'VesselStatusGrid';
            ExportAction.ExportSelectedRows(this.state.gridApiParams, formName);
            //var uri = Excel.InitializeChildGridExportToExcel(arrData, r, formName);
            //this.state.exportFields.ExportData = JSON.stringify(uri);
            //var sheetData = { HeaderData: [], ColumnData: [] };
            //sheetData = Excel.ConvertCSVToJSon(uri);
            //GridToolBarExcel.applySheetData(sheetData, formName);
        }
        catch (ex) {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Error in data export.");
        }
    }
    //26668 - start
    onRowDataChanged(params: any): void {
        var reeferIdSelected = "";
        if (self.state.IsCommandIssued && self.state.PrevSelectedItems.length > 0) {
            reeferIdSelected = self.state.PrevSelectedItems[0].ReeferID;
        }
        var TotalCount = 0;
        var PageSize = self.state.pageSize;
        var TempCount = 0;
        var gridData = self.state.reeferStatusData;
        if (gridData != null && gridData != undefined && gridData.length > 0) {
            TotalCount = gridData.length;
            params.api.setFunctionsReadOnly(false);
        } else {
            params.api.setFunctionsReadOnly(true);
        }
        if (TotalCount > 0 && reeferIdSelected !== "") {
            let count = 0;
            if (reeferIdSelected) {
                params.api.forEachLeafNode((node) => {
                    count = count + 1;
                    if (node.data.ReeferID === reeferIdSelected) {
                        TempCount = count;
                        var pageNo = Math.ceil((TempCount / PageSize));
                        var setPageNum = pageNo - 1;
                        params.api.paginationGoToPage(setPageNum);
                        var currentParent = node.parent;
                        while (currentParent) {
                            currentParent.setExpanded(true);
                            currentParent = currentParent.parent;
                        }
                        node.setExpanded(true);
                        node.setSelected(true);
                        self.setState({ IsCommandIssued: false });
                        return;
                    }
                });
            }
        }
    }
    //26668 - end
    onSelectionChanged(params: any) {
        if (self.props.loggedInUserData != null) {
            sessionStorage.setItem("userRights", JSON.stringify(self.props.loggedInUserData.User.Customer.Rights));
        }

        //var rights = JSON.parse(sessionStorage.getItem('userRights'));
        //var rights = self.props.loggedInUserData.User.Customer.Rights;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });

        //var selectedItems = self.state.selectedItems;
        //26668 - commenting below and adding 
        //self.setState({ selectedItems: selectedReeferData });
        self.setState({
            selectedItems: selectedReeferData,
            isChangeDeforstInterval: false,
            pretripCmd: null,
            modelTitle: '',
            popUpHtml: ''
        });

        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        var isST9100Present = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT5000') {
                    isDeviceTypeFound = isDeviceTypeFound + 1;
                }
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                }
                if (val.DeviceType.toString().trim() == 'ST9100') {
                    isST9100Present = isST9100Present + 1;
                }
            }
        });
        if (isST9100Present > 0) {
            $('#liCargoCareTasksRequiresRight').addClass('hidden');
            $('#liCommandsRequiresRight').addClass('hidden');
        }
        else {
            $('#liCargoCareTasksRequiresRight').removeClass('hidden');
            $('#liCommandsRequiresRight').removeClass('hidden');
        }

        var tripWISEReport;
        tripWISEReport = JSON.parse(sessionStorage.getItem('customerDetails')).TripWISEreport;

        // showing Selected commands for device Type CT5000
        if (isDeviceTypeFound > 0) {
            if ($("#liPingRequiresRight").hasClass("show")) $('#liPingRequiresRight').removeClass('hidden');
            if ($("#liSetpointRequiresRight").hasClass("show")) $('#liSetpointRequiresRight').removeClass('hidden');
            if ($("#liHumidityRequiresRight").hasClass("show")) $('#liHumidityRequiresRight').removeClass('hidden');
            if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').removeClass('hidden');
            if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').removeClass('hidden');
            if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('hidden');
            if ($("#liDefrostRequiresRight").hasClass("show")) $('#liDefrostRequiresRight').removeClass('hidden');
            if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
            if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
            if ($("#liStartDefrostRequiresRight").hasClass("show")) $('#liStartDefrostRequiresRight').removeClass('hidden');
            if ($("#liChangeDefrostIntervalRequiresRight").hasClass("show")) $('#liChangeDefrostIntervalRequiresRight').removeClass('hidden');
            if ($("#liRebootReeferController").hasClass("show")) $('#liRebootReeferController').removeClass('hidden');

            if ($("#liReportingIntervalRequiresRight").hasClass("show")) $('#liReportingIntervalRequiresRight').addClass('hidden');
            if ($("#liDeviceResetRequiresRight").hasClass("show")) $('#liDeviceResetRequiresRight').addClass('hidden');
            if ($("#liDeviceHardResetRequiresRight").hasClass("show")) $('#liDeviceHardResetRequiresRight').addClass('hidden');
            if ($("#liSyncReeferClockRequiresRight").hasClass("show")) $('#liSyncReeferClockRequiresRight').addClass('hidden');
            if ($("#lichangereeferclocksettingRequiresRight").hasClass("show")) $('#lichangereeferclocksettingRequiresRight').addClass('hidden');
            if ($("#liUpdateContainerIdRequiresRight").hasClass("show")) $('#liUpdateContainerIdRequiresRight').addClass('hidden');
            if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').addClass('hidden');
            if ($("#liTraditionalDownloadRequiresRight").hasClass("show")) $('#liTraditionalDownloadRequiresRight').addClass('hidden');
            if ($("#liUpdateDatalogRequiresRight").hasClass("show")) $('#liUpdateDatalogRequiresRight').addClass('hidden');
            if ($("#liManagerealTimedSettingsRequiresRight").hasClass("show")) $('#liManagerealTimedSettingsRequiresRight').addClass('hidden');
            if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').addClass('hidden');
            if ($("#liStartPreTripFrozenRequiresRight").hasClass("show")) $('#liStartPreTripFrozenRequiresRight').addClass('hidden');
            if ($("#liStartPreTripCARequriesRight").hasClass("show")) $('#liStartPreTripCARequriesRight').addClass('hidden');
            if ($("#liStartCAFullPTIRequriesRight").hasClass("show")) $('#liStartCAFullPTIRequriesRight').addClass('hidden');
            if ($("#liStartCAFuntionTestRequriesRight").hasClass("show")) $('#liStartCAFuntionTestRequriesRight').addClass('hidden');
            if ($("#liStopPreTripRequiresRight").hasClass("show")) $('#liStopPreTripRequiresRight').addClass('hidden');
            if ($("#liScheduledPreTripRequiresRight").hasClass("show")) $('#liScheduledPreTripRequiresRight').addClass('hidden');
            if ($("#lilastpretripresultRequiresRight").hasClass("show")) $('#lilastpretripresultRequiresRight').addClass('hidden');
            if ($("#lilastpretripreportRequiresRight").hasClass("show")) $('#lilastpretripreportRequiresRight').addClass('hidden');
            if ($("#litripwiseReportRequiresRight").hasClass("show")) $('#litripwiseReportRequiresRight').addClass('hidden');
            if ($("#liUploadFirmwareRequiresRight").hasClass("show")) $('#liUploadFirmwareRequiresRight').addClass('hidden');
            if ($("#liQueryReeferInventoryRequiresRight").hasClass("show")) $('#liQueryReeferInventoryRequiresRight').addClass('hidden');
            if ($("#liUpdateModelConfigurationRequiresRight").hasClass("show")) $('#liUpdateModelConfigurationRequiresRight').addClass('hidden');
            if ($("#liVerifyModelValidityRequiresRight").hasClass("show")) $('#liVerifyModelValidityRequiresRight').addClass('hidden');
            if ($("#liMSCRequiresRight").hasClass("show")) $('#liMSCRequiresRight').addClass('hidden');
            if ($("#liACTRequiresRight").hasClass("show")) $('#liACTRequiresRight').addClass('hidden');
            if ($("#liassignGuestreeferRequiresRight").hasClass("show")) $('#liassignGuestreeferRequiresRight').addClass('hidden');
            if ($("#liZigbeesettingsRequiresRight").hasClass("show")) $('#liZigbeesettingsRequiresRight').addClass('hidden');
            if ($("#liassignpanidRequiresRight").hasClass("show")) $('#liassignpanidRequiresRight').addClass('hidden');
            if ($("#liAutoConfigurationRequiresRight").hasClass("show")) $('#liAutoConfigurationRequiresRight').addClass('hidden');
            if ($("#liAssetConfigurationRequiresRight").hasClass("show")) $('#liAssetConfigurationRequiresRight').addClass('hidden');
            if ($("#liFreshAirTypeRequiresRight").hasClass("show")) $('#liFreshAirTypeRequiresRight').addClass('hidden');
            if ($("#liGetFreshAirTypeRequiresRight").hasClass("show")) $('#liGetFreshAirTypeRequiresRight').addClass('hidden');
            if ($("#liSetFreshAirTypeRequiresRight").hasClass("show")) $('#liSetFreshAirTypeRequiresRight').addClass('hidden');
            if ($("#liClockRequiresRight").hasClass("show")) $('#liClockRequiresRight').addClass('hidden');
            if ($("#liReeferDataLogRequiresRight").hasClass("show")) $('#liReeferDataLogRequiresRight').addClass('hidden');
            if ($("#liReeferModelConfiguration").hasClass("show")) $('#liReeferModelConfiguration').addClass('hidden');
            if ($("#liStartPreTripChilledandCARequiresRight").hasClass("show")) $('#liStartPreTripChilledandCARequiresRight').addClass('hidden');
        }
        else {
            if ($("#liPingRequiresRight").hasClass("show")) $('#liPingRequiresRight').removeClass('hidden');
            if ($("#liSetpointRequiresRight").hasClass("show")) $('#liSetpointRequiresRight').removeClass('hidden');
            if ($("#liHumidityRequiresRight").hasClass("show")) $('#liHumidityRequiresRight').removeClass('hidden');
            if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').removeClass('hidden');
            if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').removeClass('hidden');
            if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('hidden');
            if ($("#liDefrostRequiresRight").hasClass("show")) $('#liDefrostRequiresRight').removeClass('hidden');
            if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
            if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
            if ($("#liStartDefrostRequiresRight").hasClass("show")) $('#liStartDefrostRequiresRight').removeClass('hidden');
            if ($("#liChangeDefrostIntervalRequiresRight").hasClass("show")) $('#liChangeDefrostIntervalRequiresRight').removeClass('hidden');
            if ($("#liRebootReeferController").hasClass("show")) $('#liRebootReeferController').removeClass('hidden');
            if ($("#liReportingIntervalRequiresRight").hasClass("show")) $('#liReportingIntervalRequiresRight').removeClass('hidden');
            if ($("#liDeviceResetRequiresRight").hasClass("show")) $('#liDeviceResetRequiresRight').removeClass('hidden');
            if ($("#liDeviceHardResetRequiresRight").hasClass("show")) $('#liDeviceHardResetRequiresRight').removeClass('hidden');
            if ($("#liSyncReeferClockRequiresRight").hasClass("show")) $('#liSyncReeferClockRequiresRight').removeClass('hidden');
            if ($("#lichangereeferclocksettingRequiresRight").hasClass("show")) $('#lichangereeferclocksettingRequiresRight').removeClass('hidden');
            if ($("#liUpdateContainerIdRequiresRight").hasClass("show")) $('#liUpdateContainerIdRequiresRight').removeClass('hidden');
            if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').removeClass('hidden');
            if ($("#liTraditionalDownloadRequiresRight").hasClass("show")) $('#liTraditionalDownloadRequiresRight').removeClass('hidden');
            if ($("#liUpdateDatalogRequiresRight").hasClass("show")) $('#liUpdateDatalogRequiresRight').removeClass('hidden');
            if ($("#liManagerealTimedSettingsRequiresRight").hasClass("show")) $('#liManagerealTimedSettingsRequiresRight').removeClass('hidden');
            if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').removeClass('hidden');
            if ($("#liStartPreTripFrozenRequiresRight").hasClass("show")) $('#liStartPreTripFrozenRequiresRight').removeClass('hidden');
            if ($("#liStartPreTripCARequriesRight").hasClass("show")) $('#liStartPreTripCARequriesRight').removeClass('hidden');
            if ($("#liStartCAFullPTIRequriesRight").hasClass("show")) $('#liStartCAFullPTIRequriesRight').removeClass('hidden');
            if ($("#liStartCAFuntionTestRequriesRight").hasClass("show")) $('#liStartCAFuntionTestRequriesRight').removeClass('hidden');
            if ($("#liStopPreTripRequiresRight").hasClass("show")) $('#liStopPreTripRequiresRight').removeClass('hidden');
            if ($("#liScheduledPreTripRequiresRight").hasClass("show")) $('#liScheduledPreTripRequiresRight').removeClass('hidden');
            if ($("#lilastpretripresultRequiresRight").hasClass("show")) $('#lilastpretripresultRequiresRight').removeClass('hidden');
            if ($("#lilastpretripreportRequiresRight").hasClass("show")) $('#lilastpretripreportRequiresRight').removeClass('hidden');
            if ($("#liUploadFirmwareRequiresRight").hasClass("show")) $('#liUploadFirmwareRequiresRight').removeClass('hidden');
            if ($("#liQueryReeferInventoryRequiresRight").hasClass("show")) $('#liQueryReeferInventoryRequiresRight').removeClass('hidden');
            if ($("#liUpdateModelConfigurationRequiresRight").hasClass("show")) $('#liUpdateModelConfigurationRequiresRight').removeClass('hidden');
            if ($("#liVerifyModelValidityRequiresRight").hasClass("show")) $('#liVerifyModelValidityRequiresRight').removeClass('hidden');
            if ($("#liMSCRequiresRight").hasClass("show")) $('#liMSCRequiresRight').removeClass('hidden');
            if ($("#liACTRequiresRight").hasClass("show")) $('#liACTRequiresRight').removeClass('hidden');
            if ($("#liassignGuestreeferRequiresRight").hasClass("show")) $('#liassignGuestreeferRequiresRight').removeClass('hidden');
            if ($("#liZigbeesettingsRequiresRight").hasClass("show")) $('#liZigbeesettingsRequiresRight').removeClass('hidden');
            if ($("#liassignpanidRequiresRight").hasClass("show")) $('#liassignpanidRequiresRight').removeClass('hidden');
            if ($("#liAutoConfigurationRequiresRight").hasClass("show")) $('#liAutoConfigurationRequiresRight').removeClass('hidden');
            if ($("#liAssetConfigurationRequiresRight").hasClass("show")) $('#liAssetConfigurationRequiresRight').removeClass('hidden');
            if ($("#liFreshAirTypeRequiresRight").hasClass("show")) $('#liFreshAirTypeRequiresRight').removeClass('hidden');
            if ($("#liGetFreshAirTypeRequiresRight").hasClass("show")) $('#liGetFreshAirTypeRequiresRight').removeClass('hidden');
            if ($("#liSetFreshAirTypeRequiresRight").hasClass("show")) $('#liSetFreshAirTypeRequiresRight').removeClass('hidden');
            if ($("#liClockRequiresRight").hasClass("show")) $('#liClockRequiresRight').removeClass('hidden');
            if ($("#liReeferDataLogRequiresRight").hasClass("show")) $('#liReeferDataLogRequiresRight').removeClass('hidden');
            if ($("#liReeferModelConfiguration").hasClass("show")) $('#liReeferModelConfiguration').removeClass('hidden');
            if ($("#liStartPreTripChilledandCARequiresRight").hasClass("show")) $('#liStartPreTripChilledandCARequiresRight').addClass('hidden');
            if (isCT4Found > 0 && tripWISEReport == true) {
                if ($("#litripwiseReportRequiresRight").hasClass("show")) $('#litripwiseReportRequiresRight').removeClass('hidden');
            }
            else {
                if ($("#litripwiseReportRequiresRight").hasClass("show")) $('#litripwiseReportRequiresRight').addClass('hidden');
            }

            var forwardCommandParams = JSON.stringify(selectedReeferData);
            var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetCCAlarmStatus';
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<boolean>)
                .then(data => {
                    if (data) {
                        $('#liClearSetPoint').removeClass('disabled');
                        $("#liClearSetPoint").addClass('enabled');
                    }
                    else {
                        $('#liClearSetPoint').removeClass('enabled');
                        $("#liClearSetPoint").addClass('disabled');
                    }
                });

            if (selectedReeferData.length > 1) {
                $('#liDetailsRequiresRight').removeClass('enabled');
                $('#liDetailsRequiresRight').addClass('disabled');
                $('#lilastpretripreportRequiresRight').removeClass('enabled');
                $('#lilastpretripreportRequiresRight').addClass('disabled');
                $('#litripwiseReportRequiresRight').removeClass('enabled');
                $('#litripwiseReportRequiresRight').addClass('disabled');
                $('#liUpdateContainerIdRequiresRight').removeClass('enabled');
                $('#liUpdateContainerIdRequiresRight').addClass('disabled');
                $('#liZigbeesettingsRequiresRight').hide();
                var isGuestFound;

                isGuestFound = selectedReeferData.filter(row => row.DeviceConfig == true);

                if (isGuestFound.length > 0) {
                    //PopupWindow.showErrorMessage("Alert", "Device Config must be same for all selected rows.");
                    $('#liReportingIntervalRequiresRight').removeClass('enabled');
                    $('#liReportingIntervalRequiresRight').addClass('disabled');
                }
                else {

                    $('#liReportingIntervalRequiresRight').removeClass('disabled');
                    $('#liReportingIntervalRequiresRight').addClass('enabled');
                }

                if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
                if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
                if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').removeClass('hidden');
                if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').removeClass('hidden');
                if ($("#liStartPreTripFrozenRequiresRight").hasClass("show")) $('#liStartPreTripFrozenRequiresRight').removeClass('hidden');
                if ($("#liStartPreTripCARequriesRight").hasClass("show")) $('#liStartPreTripCARequriesRight').removeClass('hidden');
                if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('hidden');
                if ($("#liHumidityRequiresRight").hasClass("show")) $('#liHumidityRequiresRight').removeClass('hidden');
                if ($("#liStartCAFullPTIRequriesRight").hasClass("show")) $('#liStartCAFullPTIRequriesRight').removeClass('hidden');
                if ($("#liStartCAFuntionTestRequriesRight").hasClass("show")) $('#liStartCAFuntionTestRequriesRight').removeClass('hidden');

                if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'C').length) {
                    if (isGuestFound.length == selectedReeferData.length) {
                        if ($("#liHumidityRequiresRight").hasClass("show")) $('#liHumidityRequiresRight').addClass('hidden');
                    }
                    else {
                        if ($("#liHumidityRequiresRight").hasClass("show")) $('#liHumidityRequiresRight').removeClass('hidden');
                    }
                }
                else {
                    if ($("#liHumidityRequiresRight").hasClass("show")) $('#liHumidityRequiresRight').removeClass('hidden');
                }

                if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'D').length) {
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').addClass('hidden');
                    if ($("#liStartPreTripFrozenRequiresRight").hasClass("show")) $('#liStartPreTripFrozenRequiresRight').removeClass('hidden');
                    if ($("#liStartPreTripCARequriesRight").hasClass("show")) $('#liStartPreTripCARequriesRight').removeClass('hidden');
                }
                else {
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
                    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('hidden');
                    if ($("#liStartPreTripFrozenRequiresRight").hasClass("show")) $('#liStartPreTripFrozenRequiresRight').addClass('hidden');
                    if ($("#liStartPreTripCARequriesRight").hasClass("show")) $('#liStartPreTripCARequriesRight').addClass('hidden');
                }

                if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'D').length) {
                    if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').removeClass('hidden');
                    if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').removeClass('hidden');
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                }
                else if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'S').length) {
                    if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').addClass('hidden');
                    if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').removeClass('hidden');
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                }
                else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'S').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'S').length)) {
                    if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').addClass('hidden');
                    if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').removeClass('hidden');
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                }
                else {
                    if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').addClass('hidden');
                    if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').addClass('hidden');
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
                }

                if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'S').length) {
                    if ($("#liStartCAFullPTIRequriesRight").hasClass("show")) $('#liStartCAFullPTIRequriesRight').removeClass('hidden');
                    if ($("#liStartCAFuntionTestRequriesRight").hasClass("show")) $('#liStartCAFuntionTestRequriesRight').removeClass('hidden');
                }
                else {
                    if ($("#liStartCAFullPTIRequriesRight").hasClass("show")) $('#liStartCAFullPTIRequriesRight').addClass('hidden');
                    if ($("#liStartCAFuntionTestRequriesRight").hasClass("show")) $('#liStartCAFuntionTestRequriesRight').addClass('hidden');
                }

                if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'S').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'C' && row.DeviceConfig == true).length)) {
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                }
                else {
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
                }
                if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'C' && row.DeviceConfig == true).length) {
                    if ($("#liUpdateDatalogRequiresRight").hasClass("show")) $('#liUpdateDatalogRequiresRight').addClass('hidden');
                }
                else {
                    if ($("#liUpdateDatalogRequiresRight").hasClass("show")) $('#liUpdateDatalogRequiresRight').removeClass('hidden');
                }

                if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'D').length)) {
                    if ($("#liStartPreTripChilledandCARequiresRight").hasClass("show")) $('#liStartPreTripChilledandCARequiresRight').removeClass('hidden');
                }
                else {
                    if ($("#liStartPreTripChilledandCARequiresRight").hasClass("show")) $('#liStartPreTripChilledandCARequiresRight').addClass('hidden');
                }
                if (selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'S').length > 0) {
                    if ($("#liChangeDefrostIntervalRequiresRight").hasClass("show")) $('#liChangeDefrostIntervalRequiresRight').addClass('hidden');
                }

                if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd.trim() == 'C').length)) {
                    if ($("#liReeferModelConfiguration").hasClass("show")) $('#liReeferModelConfiguration').addClass('show');
                    if ($("#liReeferModelConfiguration").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('hidden');
                }
                else {
                    if ($("#liReeferModelConfiguration").hasClass("show")) $('#liReeferModelConfiguration').addClass('hidden');
                    if ($("#liReeferModelConfiguration").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('show');
                }
            }
            else {
                var dflag = selectedReeferData[0].DeviationFlg;
                var csflag = selectedReeferData[0].ControllerSerialNumberChgFlag;
                var isAssignCargo = selectedReeferData[0].IsCargoCare;
                //var liassignvslRequiresRight = selectedReeferData[0].IsOnVessel;
                var ReeferOEMTypeCd = selectedReeferData[0].ReeferOEMTypeCd != null ? selectedReeferData[0].ReeferOEMTypeCd : "";

                var IsGuest = selectedReeferData[0].DeviceConfig;

                if (IsGuest) {
                    $('#liReportingIntervalRequiresRight').removeClass('enabled');
                    $('#liReportingIntervalRequiresRight').addClass('disabled');
                }
                else {
                    $('#liReportingIntervalRequiresRight').removeClass('disabled');
                    $('#liReportingIntervalRequiresRight').addClass('enabled');
                }
                if (ReeferOEMTypeCd.trim() == 'U') {
                    $('#liDefrostRequiresRight').removeClass('enabled');
                    $('#liDefrostRequiresRight').addClass('disabled');
                    $('#liPreTripRequiresRight').removeClass('enabled');
                    $('#liPreTripRequiresRight').addClass('disabled');
                    $('#liStopPreTripRequiresRight').removeClass('enabled');
                    $('#liStopPreTripRequiresRight').addClass('disabled');
                } else {
                    $('#liPreTripRequiresRight').removeClass('disabled');
                    $('#liPreTripRequiresRight').addClass('enabled');
                    $('#liStopPreTripRequiresRight').removeClass('disabled');
                    $('#liStopPreTripRequiresRight').addClass('enabled');
                    $('#liDefrostRequiresRight').removeClass('disabled');
                    $('#liDefrostRequiresRight').addClass('enabled');
                }
                if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined) {

                    if (ReeferOEMTypeCd.toString().trim() == 'C') {
                        if ($("#liReeferModelConfiguration").hasClass("show")) $('#liReeferModelConfiguration').addClass('show');
                        if ($("#liReeferModelConfiguration").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('hidden');
                    }
                    else {
                        if ($("#liReeferModelConfiguration").hasClass("show")) $('#liReeferModelConfiguration').addClass('hidden');
                        if ($("#liReeferModelConfiguration").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('show');
                    }
                }
                if (ReeferOEMTypeCd.trim() == 'TR') {
                    $('#liVerifyModelValidityRequiresRight').removeClass('enabled');
                    $('#liVerifyModelValidityRequiresRight').addClass('disabled');
                }
                else {
                    $('#liVerifyModelValidityRequiresRight').removeClass('disabled');
                    $('#liVerifyModelValidityRequiresRight').addClass('enabled');
                }
                if (ReeferOEMTypeCd.trim() == 'S') {
                    $('#liChangeDefrostIntervalRequiresRight').removeClass('enabled');
                    $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
                }
                else {
                    $('#liChangeDefrostIntervalRequiresRight').removeClass('disabled');
                    $('#liChangeDefrostIntervalRequiresRight').addClass('enabled');
                }
                if (ReeferOEMTypeCd.trim() == 'C') {
                    $('#liChangeDefrostIntervalRequiresRight').removeClass('enabled');
                    $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
                    if (IsGuest) {
                        if ($("#liHumidityRequiresRight").hasClass("show")) $('#liHumidityRequiresRight').addClass('hidden');
                    }
                    else {
                        if ($("#liHumidityRequiresRight").hasClass("show")) $('#liHumidityRequiresRight').removeClass('hidden');
                    }
                }
                else {
                    $('#liChangeDefrostIntervalRequiresRight').removeClass('disabled');
                    $('#liChangeDefrostIntervalRequiresRight').addClass('enabled');
                }
                //if (ReeferOEMTypeCd.trim() == 'D') {
                //    $('#liDefrostRequiresRight').removeClass('enabled');
                //    $('#liDefrostRequiresRight').addClass('disabled');
                //    $('#liChangeDefrostIntervalRequiresRight').removeClass('enabled');
                //    $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
                //}
                //else {
                //    $('#liDefrostRequiresRight').removeClass('disabled');
                //    $('#liDefrostRequiresRight').addClass('enabled');
                //    $('#liChangeDefrostIntervalRequiresRight').removeClass('disabled');
                //    $('#liChangeDefrostIntervalRequiresRight').addClass('enabled');
                //}
                if (ReeferOEMTypeCd.trim() == 'T') {
                    $('#liChangeDefrostIntervalRequiresRight').removeClass('enabled');
                    $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
                }
                else {
                    $('#liChangeDefrostIntervalRequiresRight').removeClass('disabled');
                    $('#liChangeDefrostIntervalRequiresRight').addClass('enabled');
                }

                //if (!liassignvslRequiresRight) {
                //    $('#liAssignVSLRequiresRight').removeClass('disabled');
                //    $('#liAssignVSLRequiresRight').addClass('enabled');
                //    $('#liUnassignVSLRequiresRight').removeClass('enabled');
                //    $('#liUnassignVSLRequiresRight').addClass('disabled');
                //} else {
                //    $('#liAssignVSLRequiresRight').removeClass('enabled');
                //    $('#liAssignVSLRequiresRight').addClass('disabled');
                //    $('#liUnassignVSLRequiresRight').removeClass('disabled');
                //    $('#liUnassignVSLRequiresRight').addClass('enabled');
                //}

                if (isAssignCargo) {
                    $('#liUnassignCCRequiresRight').removeClass('disabled');
                    $('#liUnassignCCRequiresRight').addClass('enabled');
                    $('#liAssignCCRequiresRight').removeClass('enabled');
                    $('#liAssignCCRequiresRight').addClass('disabled');
                }
                else {
                    $('#liUnassignCCRequiresRight').removeClass('enabled');
                    $('#liUnassignCCRequiresRight').addClass('disabled');
                    $('#liAssignCCRequiresRight').removeClass('disabled');
                    $('#liAssignCCRequiresRight').addClass('enabled');
                }

                if (ReeferOEMTypeCd.trim() == 'D') {
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').addClass('hidden');
                    if ($("#liStartPreTripFrozenRequiresRight").hasClass("show")) $('#liStartPreTripFrozenRequiresRight').removeClass('hidden');
                    if ($("#liStartPreTripCARequriesRight").hasClass("show")) $('#liStartPreTripCARequriesRight').removeClass('hidden');
                }
                else {
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
                    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('hidden');
                    if ($("#liStartPreTripFrozenRequiresRight").hasClass("show")) $('#liStartPreTripFrozenRequiresRight').addClass('hidden');
                    if ($("#liStartPreTripCARequriesRight").hasClass("show")) $('#liStartPreTripCARequriesRight').addClass('hidden');
                }

                if (ReeferOEMTypeCd.trim() == 'D') {
                    if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').removeClass('hidden');
                    if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').removeClass('hidden');
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                }
                else if (ReeferOEMTypeCd.trim() == 'S') {
                    if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').addClass('hidden');
                    if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').removeClass('hidden');
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                }
                else {
                    if ($("#liStartPreTripChilledRequiresRight").hasClass("show")) $('#liStartPreTripChilledRequiresRight').addClass('hidden');
                    if ($("#liControlledAtmosphereRight").hasClass("show")) $('#liControlledAtmosphereRight').addClass('hidden');
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
                }

                if (ReeferOEMTypeCd.trim() == 'S') {
                    if ($("#liStartCAFullPTIRequriesRight").hasClass("show")) $('#liStartCAFullPTIRequriesRight').removeClass('hidden');
                    if ($("#liStartCAFuntionTestRequriesRight").hasClass("show")) $('#liStartCAFuntionTestRequriesRight').removeClass('hidden');
                }
                else {
                    if ($("#liStartCAFullPTIRequriesRight").hasClass("show")) $('#liStartCAFullPTIRequriesRight').addClass('hidden');
                    if ($("#liStartCAFuntionTestRequriesRight").hasClass("show")) $('#liStartCAFuntionTestRequriesRight').addClass('hidden');
                }
                if ((ReeferOEMTypeCd.trim() == 'C' && IsGuest) || (ReeferOEMTypeCd.trim() == 'S') || (ReeferOEMTypeCd.trim() == 'D')) {

                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').addClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').addClass('hidden');
                }
                else {
                    if ($("#liO2SetPointRequiresRight").hasClass("show")) $('#liO2SetPointRequiresRight').removeClass('hidden');
                    if ($("#liCO2SetPointRequiresRight").hasClass("show")) $('#liCO2SetPointRequiresRight').removeClass('hidden');
                }

                if (ReeferOEMTypeCd.trim() == 'C' && IsGuest) {
                    if ($("#liUpdateDatalogRequiresRight").hasClass("show")) $('#liUpdateDatalogRequiresRight').addClass('hidden');
                }
                else {
                    if ($("#liUpdateDatalogRequiresRight").hasClass("show")) $('#liUpdateDatalogRequiresRight').removeClass('hidden');
                }
                if (ReeferOEMTypeCd.trim() == 'D') {
                    if ($("#liStartPreTripChilledandCARequiresRight").hasClass("show")) $('#liStartPreTripChilledandCARequiresRight').removeClass('hidden');
                }
                else {
                    if ($("#liStartPreTripChilledandCARequiresRight").hasClass("show")) $('#liStartPreTripChilledandCARequiresRight').addClass('hidden');
                }
                $('#liDetailsRequiresRight').removeClass('disabled');
                $('#liDetailsRequiresRight').addClass('enabled');
                $('#liUpdateContainerIdRequiresRight').removeClass('disabled');
                $('#liUpdateContainerIdRequiresRight').addClass('enabled');

                if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined) {
                    if (ReeferOEMTypeCd.trim() == 'T' || ReeferOEMTypeCd.trim() == 'U') {
                        $('#lilastpretripreportRequiresRight').removeClass('enabled');
                        $('#lilastpretripreportRequiresRight').addClass('disabled');
                        $('#litripwiseReportRequiresRight').removeClass('enabled');
                        $('#litripwiseReportRequiresRight').addClass('disabled');
                    }
                    else {
                        $('#lilastpretripreportRequiresRight').removeClass('disabled');
                        $('#lilastpretripreportRequiresRight').addClass('enabled');
                        if (isCT4Found > 0 && tripWISEReport == true) {
                            $('#litripwiseReportRequiresRight').removeClass('disabled');
                            $('#litripwiseReportRequiresRight').addClass('enabled');
                        }
                        else {
                            $('#litripwiseReportRequiresRight').removeClass('enabled');
                            $('#litripwiseReportRequiresRight').addClass('disabled');
                        }
                    }
                }
                else {
                    $('#lilastpretripreportRequiresRight').removeClass('enabled');
                    $('#lilastpretripreportRequiresRight').addClass('disabled');
                    $('#litripwiseReportRequiresRight').removeClass('enabled');
                    $('#litripwiseReportRequiresRight').addClass('disabled');
                }
                if (ReeferOEMTypeCd.trim() == 'S') {
                    if ($("#liChangeDefrostIntervalRequiresRight").hasClass("show")) $('#liChangeDefrostIntervalRequiresRight').addClass('hidden');
                }
            }
        }
    }

    setCommandText(Oem: any) {
        var url = '/api/reeferstatus/GetCustomerSpecificCommandLabel';
        var input = JSON.stringify(Oem);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + url, { method: 'POST', body: input, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    fullPreTripCommandText: data[0] != 'disabled' ? data[0] : 'Full',
                    shortPreTripCommandText: data[1] != 'disabled' ? data[1] : 'Short',
                    funcPreTripCommandText: data[2] != 'disabled' ? data[2] : 'Function Test'
                });
                if (data[0] == 'disabled') {
                    if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').addClass('disabled');
                    if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').removeClass('enabled');
                }
                else {
                    if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').removeClass('disabled');
                    if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').addClass('enabled');
                }
                if (data[1] == 'disabled') {
                    if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').addClass('disabled');
                    if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').removeClass('enabled');
                }
                else {
                    if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').addClass('enabled');
                    if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').removeClass('disabled');
                }

                if (data[2] == 'disabled') {
                    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').addClass('disabled');
                    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('enabled');
                }
                else {
                    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').addClass('enabled');
                    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('disabled');
                }
            });
    }

    getCommandWindowText(Oem: any[], command: string) {
        var url = '/api/reeferstatus/GetCustomerSpecificCommandData';
        this.state.CustomerSpecificCommandData.Oem = Oem;
        this.state.CustomerSpecificCommandData.commandId = command;

        var input = JSON.stringify(this.state.CustomerSpecificCommandData);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + url, { method: 'POST', body: input, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                self.setState({ pretripCmd: command, modelTitle: data }, () => self.RenderContextMenuPopUp('PreTrip', true));
            });
    }

    ProcessCellForClipboard(params) {
        return Formatters.CopyCommandFormatters(params);
    }

    copyRowsToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: false });//RCNG-225
    }

    copyRowsWithHeadersToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: true });//RCNG-225
    }

    getVesselContextMenuItems = params => {
        if (params != null && params != undefined && params.node != null && params.node != undefined && !params.node.group) {
            var selectflag = false;
            var selectedCell = params.api.getFocusedCell();
            var selectedRowIndex = selectedCell.rowIndex;
            var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
            if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
                var currentRowId = currentRow.id;
                coppiedData = params.value;
                var selectedrowNode = params.api.getRowNode(currentRowId);
                var reeferid = selectedrowNode.data.ReeferID;
                params.api.forEachLeafNode((newRowNode, index) => {
                    if ((newRowNode.data.ReeferID === reeferid)) {
                        selectedrowNode = newRowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, (index, item) => {
                    if (item.ReeferID == selectedrowNode.data.ReeferID) {
                        selectflag = true;
                        return false;
                    }
                });
                if (!selectflag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            var selectedReeferData = [];
            var selectedRows = params.api.getSelectedRows();
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });

            var result = [
                {
                    name: 'Copy',
                    subMenu: [
                        {
                            name: 'Copy Cell',
                            action: () => {
                                //this.reeferContextMenuClick("Copy");
                                var cellContent = this.ProcessCellForClipboard(params);
                                params.api.clipboardService.copyDataToClipboard(cellContent);

                            }
                        },
                        {
                            name: 'Copy Row(s)',
                            action: () => {
                                this.copyRowsToClipBoard();
                            }
                        },
                        {
                            name: 'Copy Row(s) with Headers',
                            action: () => {
                                this.copyRowsWithHeadersToClipBoard();
                            }
                        },
                    ],
                },
                {
                    name: 'Map',
                    action: () => {
                        this.vesselContextMenuClick("Map");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('14'),
                },
                {
                    name: 'Current Details',
                    action: () => {
                        this.vesselContextMenuClick("Details");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('154'),
                    disabled: UserRights.checkMenuItemDisabled(params, 'CurrentDetails'),
                },
                {
                    name: 'History',
                    action: () => {
                        this.vesselContextMenuClick("History");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('15'),
                },
                {
                    name: 'Command History',
                    action: () => {
                        this.vesselContextMenuClick("CommandStatus");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('155'),
                },
                {
                    name: 'CargoCare Tasks',
                    cssClasses: UserRights.checkCommandMenuItemVisibilityMultiple('76, 77', params),
                    subMenu: [
                        {
                            name: 'Assign to CargoCare',
                            action: () => {
                                this.assignCargoCare();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('76'),
                            disabled: UserRights.checkMenuItemDisabled(params, 'AssigntoCargoCare'),
                        },
                        {
                            name: 'Unassign from CargoCare',
                            action: () => {
                                this.unAssignCaregoCare();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('77'),
                            disabled: UserRights.checkMenuItemDisabled(params, 'UnassignfromCargoCare'),
                        },
                        //{
                        //    name: 'Clear Set Point',
                        //    action: () => {
                        //        this.clearSetPoint();
                        //    },
                        //    //disabled: UserRights.checkMenuItemClearSetPointDisabled(params),
                        //    disabled: UserRights.checkMenuItemDisabled(params, 'ClearSetPoint'),

                        //},
                    ],
                },
                {
                    name: 'Commands',
                    cssClasses: UserRights.checkCommandMenuItemVisibilityMultiple('18, 19, 20, 21, 22, 23, 26, 27, 24, 25, 28, 29, 30, 31, 32, 33, 80, 81, 83, 84, 85, 89, 90, 92, 103, 104, 106, 108, 109, 111, 112, 113, 114, 115, 116, 118, 122, 123, 125, 126, 145, 150, 270', params),
                    disabled: UserRights.checkMenuItemDisabledForCommands(params, 'Commands'),//RCNG-1842
                    subMenu: [
                        {
                            name: 'Reporting',
                            ////cssClasses: UserRights.checkMenuItemVisibilityMultiple('26, 81, 145, 150'),
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('26, 81, 145, 150', params, 'Reporting', self.props.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Ping / Report',
                                    action: () => {
                                        this.popUpPing();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('26', params, 'Ping', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Set Reporting Interval',
                                    action: () => {
                                        this.popUpChangeReporting();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('81', params, 'SetReportingInterval', self.props.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'SetReportingInterval'),
                                },
                                {
                                    name: 'Device Reset',
                                    action: () => {
                                        this.popUpDeviceReset();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('145', params, 'DeviceReset', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Device Reset To Defaults',
                                    action: () => {
                                        this.popUpDeviceHardReset();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('150', params, 'DeviceResetToDefaults', self.props.reeferFormatter.RefControllerTypes),
                                },
                            ],
                        },
                        {

                            name: 'Reefer Settings',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('23, 27, 24, 25, 28, 92, 108', params, 'ReeferSettings', self.props.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Change Setpoints',
                                    cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('23, 27, 24, 25', params, 'ChangeSetpoints', self.props.reeferFormatter.RefControllerTypes),
                                    subMenu: [
                                        {
                                            name: 'Temperature',
                                            action: () => {
                                                this.popUpChangeTempSetPoint();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibility('23'),
                                        },
                                        {
                                            name: 'Humidity',
                                            action: () => {
                                                this.popUpHumiditySetPoint();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('27', params, 'Humidity', self.props.reeferFormatter.RefControllerTypes),
                                            disabled: UserRights.checkMenuItemDisabled(params, 'Humidity'),
                                        },
                                        {
                                            name: 'O2',
                                            action: () => {
                                                this.popUpO2SetPoint();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('24', params, 'O2', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'CO2',
                                            action: () => {
                                                this.popUpCo2SetPoint();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('25', params, 'CO2', self.props.reeferFormatter.RefControllerTypes),
                                        },

                                    ],
                                },
                                {
                                    name: 'Clock',
                                    cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('92, 108', params, 'Clock', self.props.reeferFormatter.RefControllerTypes),
                                    subMenu: [
                                        {
                                            name: 'Sync to Device',
                                            action: () => {
                                                this.popUpSyncReeferClock();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('92', params, 'SynctoDevice', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Clock Sync Settings',
                                            action: () => {
                                                this.popUpChangeReeferClockSyncSetting();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('108', params, 'ClockSyncSettings', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                    ],
                                },
                                {
                                    name: 'Change Reefer ID',
                                    action: () => {
                                        this.popUpChangeReeferId();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('28', params, 'ChangeReeferID', self.props.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'ChangeReeferID'),
                                },
                                {
                                    name: 'Controlled Atmosphere',
                                    action: () => {
                                        this.popUpControlledAtmosphere();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('139', params, 'ControlledAtmosphere', self.props.reeferFormatter.RefControllerTypes),
                                }
                            ],
                        },
                        {
                            name: 'Reefer Data Log',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('29, 31, 32, 80', params, 'ReeferDataLog', self.props.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Get Data Log',
                                    action: () => {
                                        this.popUpDLTraditional(this);
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('31', params, 'GetDataLog', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Set Data Log Interval',
                                    action: () => {
                                        this.popUpChangeDatalog();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('29', params, 'SetDataLogInterval', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Real-Time Retrieval Settings',
                                    //action: () => {
                                    // to do Check 
                                    //this.popUpChangeDatalog();
                                    //},
                                    cssClasses: UserRights.checkMenuItemVisibility('32, 80'),
                                },
                            ],
                        },
                        {
                            name: 'Reefer Pre-Trip',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('18, 19, 20, 21, 30, 106, 206', params, 'ReeferPreTrip', self.props.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Start Pre-Trip',
                                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('18, 19, 20'),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'StartPre-Trip'),
                                    subMenu: [
                                        {
                                            name: this.state.fullPreTripCommandText.toString(),
                                            action: () => {
                                                this.popUpPreTripFull();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('18', params, 'fullPreTripCommandText', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: this.state.shortPreTripCommandText.toString(),
                                            action: () => {
                                                this.popUpPreTripShort();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('19', params, 'shortPreTripCommandText', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: this.state.funcPreTripCommandText.toString(),
                                            action: () => {
                                                this.popUpFunctionTest();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('20', params, 'funcPreTripCommandText', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Chilled',
                                            action: () => {
                                                this.popUpChangeToChilled();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('140', params, 'Chilled', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Frozen',
                                            action: () => {
                                                this.popUpChangeToFrozen();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('141', params, 'Frozen', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'CA',
                                            action: () => {
                                                this.popUpChangeToCA();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('142', params, 'CA', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'CA Full',
                                            action: () => {
                                                this.popUpChangeToCAFullPTI();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('143', params, 'CAFull', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'CA Function Test',
                                            action: () => {
                                                this.popUpChangeToCAFunctionTest();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('144', params, 'CAFunctionTest', self.props.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Chilled and CA',
                                            action: () => {
                                                this.popUpChangeToChilledandCA();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('148', params, 'ChilledandCA', self.props.reeferFormatter.RefControllerTypes),
                                        },

                                    ],
                                },
                                {
                                    name: 'Stop Pre-Trip',
                                    action: () => {
                                        this.popUpStopPTI();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('21', params, 'StopPre-Trip', self.props.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'StopPre-Trip'),
                                },
                                {
                                    name: 'Scheduled Pre-Trip',
                                    action: () => {
                                        this.popUpSchedulePTI();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('106', params, 'ScheduledPre-Trip', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Get Pre-Trip Results',
                                    action: () => {
                                        this.popUpGetPTI();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('30', params, 'GetPre-TripResults', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Show Pre-Trip Results',
                                    action: () => {
                                        this.popUpGetPTIReport();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('30', params, 'ShowPre-TripResults', self.props.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'ShowPreTripResults'),
                                },
                                ,
                                {
                                    name: 'Get TripWISE Report',
                                    action: () => {
                                        this.popUpGetTWR();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('206', params, 'GetTripWISEReport', self.props.reeferFormatter.RefControllerTypes),
                                },
                                //{
                                //    name: 'Show TripWISE Report',
                                //    action: () => {
                                //        this.popUpGetTWReport();
                                //    },
                                //    cssClasses: UserRights.checkMenuItemVisibilitybyData('206', params, 'ShowTripWISEReport'),
                                //    disabled: UserRights.checkMenuItemDisabled(params, 'ShowTripWISEReport'),
                                //},
                            ],
                        },
                        {
                            name: 'Reboot Reefer Controller',
                            action: () => {
                                this.popUpRebootReefer();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('22', params, 'RebootReeferController', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Query Reefer Inventory',
                            action: () => {
                                this.popUpQueryReefer();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('83,84,85', params, 'QueryReeferInventory', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Reefer Model Configuration',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('89, 90', params, 'ReeferModelConfiguration', self.props.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Update',
                                    action: () => {
                                        this.popUpUpdateModelConfig();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('89', params, 'Update', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Verify',
                                    action: () => {
                                        this.popUpVerifyModelValidity();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('90', params, 'Verify', self.props.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'Verify'),
                                },
                            ],

                        },
                        {
                            name: 'Defrost',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('103, 104', params, 'Defrost', self.props.reeferFormatter.RefControllerTypes),
                            disabled: UserRights.checkMenuItemDisabled(params, 'Defrost'),

                            subMenu: [

                                {
                                    name: 'Start Defrost',
                                    action: () => {
                                        this.popUpStartDeforst();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('103', params, 'StartDefrost', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Chg.Defrost Interval',
                                    action: () => {
                                        this.popUpChangeDeforstInterval();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('104', params, 'ChgDefrostInterval', self.props.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'ChgDefrostInterval'),
                                },

                            ],
                        },
                        {

                            name: 'Multiple Setpoints',
                            action: () => {
                                this.popUpMSC();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('123', params, 'MultipleSetpoints', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Automatic Cold Treatment',
                            action: () => {
                                this.popUpACT();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('122', params, 'AutomaticColdTreatment', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Guest Reefer configuration',
                            action: () => {
                                this.popUpGuestReeferConfigCmd();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('112, 113, 114, 115, 116', params, 'GuestReeferconfiguration', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Change Zigbee Config Settings',
                            action: () => {
                                this.popUpZigbeeSettings();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('118', params, 'ChangeZigbeeConfigSettings', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Assign PAN Id',
                            action: () => {
                                this.popUpAssignPanId();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('109', params, 'AssignPANId', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Device Configuration',
                            action: () => {
                                this.popAutoConfiguration();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('110', params, 'DeviceConfiguration', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Asset Configuration',
                            action: () => {
                                this.popAssetConfiguration();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('121', params, 'AssetConfiguration', self.props.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Fresh Air Type',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('125, 126', params, 'FreshAirType', self.props.reeferFormatter.RefControllerTypes),
                            subMenu: [

                                {
                                    name: 'Get - Fresh Air Type',
                                    action: () => {
                                        this.popUpGetFreshAirType();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('125', params, 'Get-FreshAirType', self.props.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Set - Fresh Air Type',
                                    action: () => {
                                        this.popUpSetFreshAirType();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('126', params, 'Set-FreshAirType', self.props.reeferFormatter.RefControllerTypes),
                                },

                            ],
                        },
                        //{
                        //    name: 'Get Asset ID',
                        //    action: () => {
                        //        this.popUpGetAssetId();
                        //    },
                        //    cssClasses: UserRights.checkMenuItemVisibilitybyData('199', params, 'GetAssetId'),
                        //},
                        //{
                        //    name: 'Enable Door Sensor',
                        //    action: () => {
                        //        this.popUpEnableDoorSensor();
                        //    },
                        //    cssClasses: UserRights.checkMenuItemVisibilitybyData('207', params, 'EnableDoorSensor'),
                        //},
                    ],
                },
                'separator',
                {
                    name: 'Export',
                    action: () => {
                        this.exportToExcel();
                    },
                },
                {
                    name: 'Send Email',
                    action: () => {
                        this.popUpSendEmail();
                    },
                },
            ];
            return result;
        }
    };

    getContextMenuItems(params: any) {
        var flag = false;
        var selected = params.api.getFocusedCell();
        var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
        var tempArray = [];// if sort is clicked save in temp array
        params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
            tempArray.push(rowNode);
        });
        var resortitem = tempArray[selected.rowIndex];
        var sortflage = false;
        var reeferid = resortitem.data.ReeferID;
        params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
            if ((NewrowNode.data.ReeferID === reeferid)) {
                selectedrowNode = NewrowNode;
                return false;
            }
        });
        $.each(self.state.selectedItems, function (index, item) {
            if (item.ReeferID == selectedrowNode.data.ReeferID) {
                flag = true;
                return false;
            }
        });
        if (!flag)
            params.api.deselectAll();
        params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
        $(".context-menu").show(); $("#contextmenu").show();
        Excel.preventDefault();

        $(".ag-cell").unbind("contextmenu");
        $(".ag-cell").bind('contextmenu', function (e) {
            $("#contextmenu").show();
            var flag = false;
            var selected = params.api.getFocusedCell();
            var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
            var tempArray = [];// if sort is clicked save in temp array
            params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
                tempArray.push(rowNode);
            });
            var resortitem = tempArray[selected.rowIndex];
            var sortflage = false;
            var reeferid = resortitem.data.ReeferID;
            params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
                if ((NewrowNode.data.ReeferID === reeferid)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.ReeferID == selectedrowNode.data.ReeferID) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
            var height = $(window).height() - 200;
            var halfheight = ($(window).height()) / 2;
            var top = e.pageY + 5;
            if (height < top) {
                top = (top - halfheight) + 170;
            }

            var left = e.pageX;
            if (left >= ($(window).width() - 200)) {
                $(".context-menu").css({
                    top: top + "px",
                    right: 20 + "px",
                    width: 160 + 'px',
                    left: $(window).width() - 200 + 'px'
                });

                $('.context-menu').find("ul.dropdown-menu").css("left", "-155px");
            }
            else {
                $(".context-menu").css({
                    top: top + "px",
                    left: left + "px"
                });

                $('.context-menu').find("ul.dropdown-menu").css("left", "155px");
            }
            $(".context-menu").show();
            e.preventDefault();
            return false;
        });

        $(document).contextmenu(function () {
            return false;
        });

        $(document).bind('contextmenu click', function () {
            $(".context-menu").hide();
        });

        $('.context-menu').bind('contextmenu', function () {
            return false;
        });
        $('.context-menu').on('click', 'li', function () {
            $(".context-menu").hide();
        });
    }

    reefermapAction(data: any[], isOpenVia: any) {
        //this.props.history.push('/reefermap', data);
        var reeferdetails = {
            reeferData: data, ReeferenceData: self.props.reeferFormatter, isOpenVia: isOpenVia
        };
        this.props.history.push('/reefermap', reeferdetails);
    }

    reeferhistoryAction(data: any[], isOpenVia: any) {
        //this.props.history.push('/reeferhistory', data);
        var reeferdetails = {
            reeferData: data, ReeferenceData: self.props.reeferFormatter, isOpenVia: isOpenVia
        };
        this.props.history.push('/reeferhistory', reeferdetails);
    }

    reefercommandstatusAction(data: any[]) {
        if (data[0].RCDID != null && data[0].RCDID != undefined && data[0].RCDID != '')
          //  this.props.history.push('/reefercommands', data);
        this.props.history.push('/reefercommands?From=' + window.location.pathname.replace('/', ''), data);
        else
            PopupWindow.showErrorMessage('Alert', 'Selected Reefers must have RCDID.');
    }

    reeferdetailsAction(data: any, dataSource: any, isOpenVia: any) {
        var reeferdetails = {
            reeferData: data[0], source: dataSource, reeferFormatter: self.props.reeferFormatter, isOpenVia: isOpenVia
        };

        //this.props.history.push('/reeferdetails', reeferdetails);
        this.props.history.push('/reeferdetails?From=' + window.location.pathname.replace('/', ''), reeferdetails);
    }

    vesselContextMenuClick(this: any, item: any) {
        switch (item) {
            case "Map": this.reefermapAction(this.state.selectedItems, 'VesselStatus');
                break;
            case "History": this.reeferhistoryAction(this.state.selectedItems, 'VesselStatus');
                break;
            case "CommandStatus": this.reefercommandstatusAction(this.state.selectedItems);
                break;
            case "Details": this.reeferdetailsAction(this.state.selectedItems, 'Vessel');
                break;
        }
    }

    //manageVessel = (param) => {
    //    var rowParams = self.state.selectedItems;
    //    if (rowParams != null && rowParams != undefined) {
    //        var isParentEventIDFound;
    //        isParentEventIDFound = rowParams.filter(row => row.ParentEventID == null);

    //        if (isParentEventIDFound.length > 0) {
    //            PopupWindow.showErrorMessage('Alert', 'Selected Reefers must have a valid Event.');
    //        }
    //        else {

    //            var url = Config.ApiBaseUrl + '/api/reeferstatus/ManageVessel';
    //            var vesselData = { reeferCommandUnits: rowParams, IsAssign: param };
    //            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(vesselData), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
    //            fetch(request)
    //                .then(RCUtils.handleError)
    //                .then(response => {
    //                    response.json() as Promise<number>;
    //                })
    //                .then(data => {
    //                    this.props.requestVesselSearch(this.props.searchFilters, vesselColumns);
    //                    if (self.state.gridApiParams != null && self.state.gridApiParams != []) {
    //                        self.state.gridApiParams.paginationGoToFirstPage();
    //                    }
    //                });
    //        }
    //    }
    //}

    getForwardCommandUnits() {
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var commandUnits = [];

        if (this.state.selectedItems.length > 0) {
            forEach(this.state.selectedItems, function (value, key) {
                var commandUnitObject = {
                    "RcdEventID": value.RCDEventID,
                    "RCDMasterID": value.RCDMasterID,
                    "RcdId": value.RCDID,
                    "ReeferID": value.ReeferID,
                    "UnitControlEventID": value.UnitControlEventID,
                    "UnitEventID": value.UnitEventID,
                    "UnitMasterID": value.UnitMasterID,
                    "ParentEventId": (value.ParentEventID.HasValue) ? value.ParentEventID.Value : 0,
                    "UserId": userData.UserId,
                    "TripId": value.TripId,

                    "RCDReportingInterval": value.RCDReportingInterval,
                    "SetTemp": value.SetPoint,
                    "CustomerID": value.CustomerID
                };

                commandUnits.push(commandUnitObject);
            });
        }
        else {
            alert('Please select at least one record to proceed.');
        }

        return commandUnits;
    }

    assignCargoCare() {
        $('#globalLoader').show();
        this.props.requestAssignCargoCare(this.getForwardCommandUnits());
        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.state.selectedItems });
    }

    unAssignCaregoCare() {
        $('#globalLoader').show();
        this.props.requestUnAssignCargoCare(this.getForwardCommandUnits());
        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.state.selectedItems });
    }

    clearSetPoint() {
        $('#globalLoader').show();
        this.props.requestClearSetPoint(this.getForwardCommandUnits());
        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.state.selectedItems });
    }

    updateVesselStatusDimensions() {
        $("#VesselStatusGrid .ag-root-wrapper-body").css('min-height', $(window).height() - 276);
        $("#VesselStatusGrid .ag-root-wrapper-body").css('height', $(window).height() - 276);
        $("#VesselStatusGrid .ag-root-wrapper-body").css('max-height', $(window).height() - 276);
    }

    //componentWillUnmount() {
    //    window.removeEventListener("resize", this.updateVesselStatusDimensions.bind(this));
    //}

    componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsOnly('38');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            //this.updateVesselStatusDimensions();
            window.addEventListener("resize", this.updateVesselStatusDimensions.bind(this));
            Excel.preventDefault();
           
           
            
            
            // To make the Modal popups draggable.
            this.dragElement(document.getElementById("contextMenuModel"));
            setTimeout(() => { this.updateVesselStatusDimensions() }, 200);
        }
    }

    popUpPing() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Ping' });
            self.RenderContextMenuPopUp('Ping', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpSendEmail() {
        self.setState({ modelTitle: 'Send Email' });
        self.RenderContextMenuPopUp('SendEmail', false);
    }

    popUpChangeTempSetPoint() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SET', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Change Temperature Setpoint' });
                self.RenderContextMenuPopUp('ChangeTempSetPoint', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpHumiditySetPoint() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('HUM', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var carrrierCount = CommonActions.validateOEMType('C', self.state.selectedItems);
                var oemDaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);

                if (oemDaikinCount > 0 && oemDaikinCount != self.state.selectedItems.length)
                    PopupWindow.showErrorMessage("Alert", "Selected reefers must be of the same OEM type.");
                else {
                    if (carrrierCount <= 0) {
                        self.setState({ modelTitle: 'Change Humidity Setpoint' });
                        self.RenderContextMenuPopUp('ChangeHumiditySetPoint', true);
                    }
                    else if (carrrierCount >= 1) {
                        var isGuestFound = 0;
                        $.each(self.state.selectedItems, function (i, val) {
                            isGuestFound = val.DeviceConfig == true && val.ReeferOEMTypeCd.trim() == 'C' ? isGuestFound + 1 : isGuestFound;
                        });

                        if (isGuestFound > 0) {
                            PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                        }
                        else {
                            self.setState({ modelTitle: 'Change Humidity Setpoint' });
                            self.RenderContextMenuPopUp('ChangeHumiditySetPoint', true);
                        }
                    }
                    else
                        PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpO2SetPoint() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('ORC', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var DaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);
                var StarCoolCount = CommonActions.validateOEMType('S', self.state.selectedItems);
                var carrrierCount = CommonActions.validateOEMType('C', self.state.selectedItems);

                if (DaikinCount >= 1 || StarCoolCount >= 1) {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Daikin and Star Cool OEMs.");
                }
                else if (carrrierCount >= 1) {
                    var isGuestFound = 0;
                    $.each(self.state.selectedItems, function (i, val) {
                        isGuestFound = val.DeviceConfig == true && val.ReeferOEMTypeCd.trim() == 'C' ? isGuestFound + 1 : isGuestFound;
                    });

                    if (isGuestFound > 0) {
                        PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                    }
                    else {
                        self.setState({ modelTitle: 'Change O2 Setpoint' });
                        self.RenderContextMenuPopUp('ChangeO2SetPoint', true);
                    }
                }
                else {
                    self.setState({ modelTitle: 'Change O2 Setpoint' });
                    self.RenderContextMenuPopUp('ChangeO2SetPoint', true);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpCo2SetPoint() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('CO2', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var DaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);
                var StarCoolCount = CommonActions.validateOEMType('S', self.state.selectedItems);
                var carrrierCount = CommonActions.validateOEMType('C', self.state.selectedItems);

                if (DaikinCount >= 1 || StarCoolCount >= 1) {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Daikin and Star Cool OEMs.");
                }
                else if (carrrierCount >= 1) {
                    var isGuestFound = 0;
                    $.each(self.state.selectedItems, function (i, val) {
                        isGuestFound = val.DeviceConfig == true ? isGuestFound + 1 : isGuestFound;
                    });

                    if (isGuestFound > 0) {
                        PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                    }
                    else {
                        self.setState({ modelTitle: 'Change CO2 Setpoint' });
                        self.RenderContextMenuPopUp('ChangeCO2SetPoint', true);
                    }
                }
                else {
                    self.setState({ modelTitle: 'Change CO2 Setpoint' });
                    self.RenderContextMenuPopUp('ChangeCO2SetPoint', true);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeToChilled() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SCH', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var oemTypeCount = CommonActions.validateOEMType('S', self.state.selectedItems);

                if (oemTypeCount >= 1) {
                    var oemValidationCount = CommonActions.validateSpecificOEMTypeForCommand('S', 'SCH', self.state.selectedItems, self.props.reeferConfigTypes);

                    if (oemValidationCount == oemTypeCount) {
                        self.setState({ pretripCmd: 'StartChilledPTI', modelTitle: 'Start Chilled Pre-Trip' });
                        self.RenderContextMenuPopUp('PreTrip', true);
                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", "Command is not supported for Star Cool OEM.");
                    }
                }
                else {
                    self.setState({ pretripCmd: 'StartChilledPTI', modelTitle: 'Start Chilled Pre-Trip' });
                    self.RenderContextMenuPopUp('PreTrip', true);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeToFrozen() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SFR', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ pretripCmd: 'StartFrozenPTI', modelTitle: 'Start Frozen Pre-Trip' });
                self.RenderContextMenuPopUp('PreTrip', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeToChilledandCA() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SCC', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var oemTypeCount = CommonActions.validateOEMType('D', self.state.selectedItems);

                if (oemTypeCount >= 1) {
                    var oemValidationCount = CommonActions.validateSpecificOEMTypeForCommand('D', 'SCC', self.state.selectedItems, self.props.reeferConfigTypes);

                    if (oemValidationCount == oemTypeCount) {
                        self.setState({ pretripCmd: 'StartChilledCAPTI', modelTitle: 'Start Chilled and CA Pre-Trip' });
                        self.RenderContextMenuPopUp('PreTrip', true);
                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", "Command is not supported for this combination of OEM Model and Software.");
                    }
                }
                else {
                    self.setState({ pretripCmd: 'StartChilledCAPTI', modelTitle: 'Start Chilled and CA Pre-Trip' });
                    self.RenderContextMenuPopUp('PreTrip', true);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeToCA() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SCT', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var DaikinCount = CommonActions.validateSpecificOEMTypeForCommand('D', 'SCT', self.state.selectedItems, self.props.reeferConfigTypes);

                if (DaikinCount == self.state.selectedItems.length) {
                    self.setState({ pretripCmd: 'StartCAPTI', modelTitle: 'Start CA Pre-Trip' });
                    self.RenderContextMenuPopUp('PreTrip', true);
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeToCAFullPTI() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SCF', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var DaikinCount = CommonActions.validateSpecificOEMTypeForCommand('S', 'SCF', self.state.selectedItems, self.props.reeferConfigTypes);

                if (DaikinCount == self.state.selectedItems.length) {
                    self.setState({ pretripCmd: 'StartCAFullPTI', modelTitle: 'Start CA Full' });
                    self.RenderContextMenuPopUp('PreTrip', true);
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeToCAFunctionTest() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SFT', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var StarCoolCount = CommonActions.validateSpecificOEMTypeForCommand('S', 'SFT', self.state.selectedItems, self.props.reeferConfigTypes);
                if (StarCoolCount == self.state.selectedItems.length) {
                    self.setState({ pretripCmd: 'StartCAFunctionTest', modelTitle: 'Start CA Function Test' });
                    self.RenderContextMenuPopUp('PreTrip', true);
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpControlledAtmosphere() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SCA', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var oemStarCoolCount = CommonActions.validateOEMType('S', self.state.selectedItems);
                var oemDaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);

                if (oemStarCoolCount == self.state.selectedItems.length) {
                    if (this.props.refApplicationParams != null && this.props.refApplicationParams != undefined) {
                        if (this.props.refApplicationParams.ValidateCACommand != null && this.props.refApplicationParams.ValidateCACommand != undefined) {
                            if (this.props.refApplicationParams.ValidateCACommand == "true") {
                                var oemValidationCount = CommonActions.validateSpecificOEMTypeForCommand('S', 'SCA', self.state.selectedItems, self.props.reeferConfigTypes);

                                if (oemValidationCount == self.state.selectedItems.length) {
                                    self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: true }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                                }
                                else {
                                    PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
                                }
                            }
                            else {
                                self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: true }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                            }
                        }
                        else {
                            self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: true }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                        }
                    }
                    else {
                        self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: true }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                    }
                }
                else if (oemDaikinCount == self.state.selectedItems.length) {
                    var DaikinCount = CommonActions.validateSpecificOEMTypeForCommand('D', 'SCA', self.state.selectedItems, self.props.reeferConfigTypes);

                    if (DaikinCount == self.state.selectedItems.length) {
                        self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: false }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                    }
                    else
                        PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
                }
                else if (oemStarCoolCount >= 1 || oemDaikinCount >= 1) {
                    PopupWindow.showErrorMessage("Alert", "Selected reefers must be of the same OEM type.");
                }
                else {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for TK and Carrier OEMs.");
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpDLTraditional(e) {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('TDD', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var validationMessage = CommonActions.validateDLCommand(self.state.selectedItems);

                if (validationMessage.OpenCommandWindow) {
                    self.setState({ modelTitle: 'Get Traditional Download' });
                    self.RenderContextMenuPopUp('GetDLTraditional', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpPreTripFull() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SFP', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                this.getCommandWindowText(self.state.selectedItems.map(x => x.ReeferOEMTypeCd), 'StartFullPTI');
                //self.setState({ pretripCmd: 'StartFullPTI', modelTitle: 'Start Full Pre-Trip' });                
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpPreTripShort() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SSP', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                this.getCommandWindowText(self.state.selectedItems.map(x => x.ReeferOEMTypeCd), 'StartShortPTI');
                //self.setState({ pretripCmd: 'StartShortPTI', modelTitle: 'Start Short Pre-Trip' });                
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpFunctionTest() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SCP', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var DaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);

                if (DaikinCount <= 0) {
                    this.getCommandWindowText(self.state.selectedItems.map(x => x.ReeferOEMTypeCd), 'StartCAShortPTI');
                    //self.setState({ pretripCmd: 'StartCAShortPTI', modelTitle: 'Start Function Test' });                    
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Daikin OEM.");
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpStopPTI() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SPP', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Stop Pre-Trip' });
                self.RenderContextMenuPopUp('StopPTI', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpSchedulePTI() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Scheduled Pre-Trip' });
            self.RenderContextMenuPopUp('SchedulePreTrip', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpGetPTI() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('LPR', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                if (self.state.selectedItems.filter(row => row.ReeferOEMTypeCd.trim() == 'D' && (row.UnitTypeCd == null || row.UnitTypeCd == "UK")).length == 0) {
                    self.setState({ modelTitle: 'Get Last Pre-Trip Result' });
                    self.RenderContextMenuPopUp('GetPTI', true);
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Selected Reefer(s) should have valid OEM Model.");
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");

    }

    popUpGetTWR() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('TWR', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Get TripWISE Report' });
                self.RenderContextMenuPopUp('GetTWR', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpRebootReefer() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('RFC', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Reboot Reefer Controller' });
                self.RenderContextMenuPopUp('RebootReefer', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeDatalog() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SDI', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var validationMessage = CommonActions.validateAllOEMs(self.state.selectedItems);
                var carrrierCount = CommonActions.validateOEMType('C', self.state.selectedItems);
                if (carrrierCount >= 1) {
                    var isGuestFound = 0;
                    $.each(self.state.selectedItems, function (i, val) {
                        isGuestFound = val.DeviceConfig == true && val.ReeferOEMTypeCd.trim() == 'C' ? isGuestFound + 1 : isGuestFound;
                    });

                    if (isGuestFound > 0) {
                        PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                    }
                    else if (validationMessage.OpenCommandWindow) {
                        self.setState({ modelTitle: 'Change Datalog Interval' });
                        self.RenderContextMenuPopUp('ChangeDatalogInterval', true);
                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                    }
                }
                else if (validationMessage.OpenCommandWindow) {
                    self.setState({ modelTitle: 'Change Datalog Interval' });
                    self.RenderContextMenuPopUp('ChangeDatalogInterval', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeReeferId() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('WRC', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Change Reefer ID' });
                self.RenderContextMenuPopUp('ChangeReeferId', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeReporting() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Change Reporting Interval' });
            self.RenderContextMenuPopUp('ChangeReportingInterval', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpQueryReefer() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('QRI', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Query Reefer Inventory' });
                self.RenderContextMenuPopUp('QueryReeferInventory', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpUpdateModelConfig() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('UMC', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Update Model Configuration' });
                self.RenderContextMenuPopUp('UpdateModelConfiguration', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpVerifyModelValidity() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('VMV', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var TKReceiverCount = CommonActions.validateOEMType('TR', self.state.selectedItems);
                if (TKReceiverCount == self.state.selectedItems.length) {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for TKReceiver OEM.");
                }
                else {
                    self.setState({ modelTitle: 'Verify Model Validity' });
                    self.RenderContextMenuPopUp('VerifyModelValidity', true);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpSyncReeferClock() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SRC', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Sync Reefer Clock' });
                self.RenderContextMenuPopUp('SyncReeferClock', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeReeferClockSyncSetting() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('RCS', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                self.setState({ modelTitle: 'Change Reefer Clock Sync Settings' });
                self.RenderContextMenuPopUp('ChangeReeferClockSyncSettings', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpStartDeforst() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('DSC', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var validationMessage = CommonActions.validateMultipleOEMs(self.state.selectedItems);

                if (validationMessage.OpenCommandWindow) {
                    self.setState({ modelTitle: 'Start Defrost' });
                    self.RenderContextMenuPopUp('StartDeforst', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpGetFreshAirType() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('GFA', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var validationMessage = CommonActions.validateCarrierDaikinThermoKingTypes(self.state.selectedItems);

                if (validationMessage.OpenCommandWindow) {
                    self.setState({ modelTitle: 'Get - Fresh Air Type' });
                    self.RenderContextMenuPopUp('GetFreshAirType', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpSetFreshAirType() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('SFA', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var validationMessage = CommonActions.validateCarrierDaikinThermoKingTypes(self.state.selectedItems);

                if (validationMessage.OpenCommandWindow) {
                    self.setState({ modelTitle: 'Set - Fresh Air Type' });
                    self.RenderContextMenuPopUp('SetFreshAirType', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpGuestReeferConfigCmd() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Guest Reefer configuration commands' });
            self.RenderContextMenuPopUp('GuestReeferConfiguration', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpChangeDeforstInterval() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('CDI', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var validationMessage = CommonActions.validateStarCoolCarrierDaikinTypes(self.state.selectedItems);

                if (validationMessage.OpenCommandWindow) {
                    this.setState({ isChangeDeforstInterval: true });
                    self.setState({ modelTitle: 'Change Defrost Interval' });
                    self.RenderContextMenuPopUp('ChangeDeforstInterval', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpAssignPanId() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Assign PAN ID' });
            self.RenderContextMenuPopUp('AssignPanId', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    //popUpAssignToCustomer() {
    //    self.setState({ modelTitle: 'Assign Units To Customer' });
    //    self.RenderContextMenuPopUp('AssignCustomer', false);
    //}

    //popUpUnAssignFromCustomer() {
    //    self.setState({ modelTitle: 'Unassign Units From Customer' });
    //    self.RenderContextMenuPopUp('UnAssignCustomer', false);
    //}

    popUpZigbeeSettings() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Change Zigbee Config Settings' });
            self.RenderContextMenuPopUp('Zigbee', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpDeviceReset() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Device Reset' });
            self.RenderContextMenuPopUp('DeviceReset', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpDeviceHardReset() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Device Reset To Defaults' });
            self.RenderContextMenuPopUp('DeviceHardReset', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popAutoConfiguration() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            if (self.state.selectedItems.length > 0) {
                var reeferData = self.state.selectedItems;
                var customerIdsCount = 0;

                $.each(reeferData, function (key, value) {
                    var customerId = reeferData[0].CustomerID;
                    if (value.CustomerID != customerId) {
                        customerIdsCount++;
                    }
                });
                if (customerIdsCount > 0) {
                    PopupWindow.showErrorMessage("Alert", "Selected Reefer(s) should be of same customer.");
                }
                else {
                    self.setState({ modelTitle: 'Device Configuration' });
                    self.RenderContextMenuPopUp('AutoConfig', true);
                }

            };
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popAssetConfiguration() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            self.setState({ modelTitle: 'Asset Configuration' });
            self.RenderContextMenuPopUp('AssetConfig', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpMSC() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('MSC', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var validationMessage = CommonActions.validateDaikinThermoKingTypes(self.state.selectedItems);

                if (validationMessage.OpenCommandWindow) {
                    self.setState({ modelTitle: 'Multiple Setpoint Change', OEM: validationMessage.OEM });
                    self.RenderContextMenuPopUp('MSC', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    popUpACT() {
        var IsValidAssociation = CommonActions.validateAssociation(self.state.selectedItems);
        if (IsValidAssociation) {
            var IsValid = CommonActions.validateCommandSupport('ACT', self.state.selectedItems, self.props.reeferConfigTypes);
            if (IsValid) {
                var validationMessage = CommonActions.validateDaikinThermoKingTypes(self.state.selectedItems);

                if (validationMessage.OpenCommandWindow) {
                    self.setState({ modelTitle: 'Automatic Cold Treatment', OEM: validationMessage.OEM });
                    self.RenderContextMenuPopUp('ACT', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Selected reefer is not associated with any device.");
    }

    refreshStatusGrid() {
        $('#globalLoader').show();
        this.setState({
            selectedItems: [],
            isChangeDeforstInterval: false,
            preTripCmd: null,
            modelTitle: '',
            popUpHtml: ''
        });

        this.props.requestVesselSearch(this.props.searchFilters, vesselColumns);
        if (self.state.gridApiParams != null && self.state.gridApiParams != []) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }
    }

    static refreshVesselStatusGrid() {
        self.refreshStatusGrid();
    }

    ComponentRenderingForCommands(popUpName: string, userData: any) {
        switch (popUpName) {
            case 'SendEmail':
                return <SendEmailControl reeferStatusResult={self.state.selectedItems} gridApiParams={this.state.gridApiParams} columnDefinition={self.props.columnDefs} parentchild={"S"} formname={"VesselStatusGrid"} />;
            case 'Ping':
                return <PingControl reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></PingControl>;
            case 'ChangeTempSetPoint':
                return <TempSetPoint reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></TempSetPoint>;
            case 'ChangeHumiditySetPoint':
                return <HumiditySetPoint reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></HumiditySetPoint>;
            case 'ChangeO2SetPoint':
                return <O2SetPoint reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></O2SetPoint>;
            case 'ChangeCO2SetPoint':
                return <CO2SetPoint reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></CO2SetPoint>;
            case 'ChangeControlledAtmosphere':
                return <ControlledAtmosphere reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} starCoolOem={this.state.isStarCoolOem} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ControlledAtmosphere>;
            case 'GetDLTraditional':
                return <TraditionalDataDownload reeferData={self.state.selectedItems} reeferFormatter={this.props.reeferFormatter} refreshGrid={"vessel"} useremail={userEmail}
                    customerId={custId} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></TraditionalDataDownload>;
            case 'PreTrip':
                return <PreTrip reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} preTripCmd={self.state.pretripCmd} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></PreTrip>;
            case 'StopPTI':
                return <StopPTI reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></StopPTI>;
            case 'SchedulePreTrip':
                return <ScheduledPreTrip reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ScheduledPreTrip>;
            case 'GetPTI':
                return <LastPretripResult reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} useremail={userEmail}
                    customerId={custId} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></LastPretripResult>;
            case 'RebootReefer':
                return <RebootReeferController reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></RebootReeferController>;
            case 'ChangeDatalogInterval':
                return <ChangeDataLogInterval reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeDataLogInterval>;
            case 'ChangeReeferId':
                return <ChangeReeferId reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeReeferId>;
            case 'ChangeReportingInterval':
                return <ChangeReportingInterval reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeReportingInterval>;
            case 'QueryReeferInventory':
                return <QueryReeferInventory reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></QueryReeferInventory>;
            case 'UpdateModelConfiguration':
                return <UpdateModelConfiguration reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></UpdateModelConfiguration>;
            case 'VerifyModelValidity':
                return <VerifyModelValidity reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></VerifyModelValidity>;
            case 'SyncReeferClock':
                return <SyncReeferClock reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></SyncReeferClock>;
            case 'StartDeforst':
                return <StartDeforst reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></StartDeforst>;
            case 'ChangeDeforstInterval':
                return <ChangeDeforstInterval reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} isChangeDeforstInterval={self.state.isChangeDeforstInterval} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeDeforstInterval>;
            case 'AssignPanId':
                return <AssignPANID reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AssignPANID>;
            case 'AssignCustomer':
                return <AssignToCustomer refreshStatusGrid={self.refreshStatusGrid.bind(this)} SelectedReefersData={self.state.selectedItems} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'UnAssignCustomer':
                return <UnassignReefersFromCustomer refreshStatusGrid={self.refreshStatusGrid.bind(this)} SelectedReefersData={self.state.selectedItems} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'ChangeReeferClockSyncSettings':
                return <ChangeReeferClockSyncSetting reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeReeferClockSyncSetting>;
            case 'GuestReeferConfiguration':
                return <GuestReeferConfiguration reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'Zigbee':
                return <ChangeZigbeeSettings reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeZigbeeSettings>;
            case 'AutoConfig':
                return <AutoConfiguration reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AutoConfiguration>;
            case 'AssetConfig':
                return <AssetConfiguration reeferData={self.state.selectedItems} reeferFormatter={this.props.reeferFormatter} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AssetConfiguration>;
            case 'MSC':
                return <MultipleSetpoints reeferData={self.state.selectedItems} reeferFormatter={this.props.reeferFormatter} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></MultipleSetpoints>;
            case 'ACT':
                return <AutomaticColdTreatment reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AutomaticColdTreatment>;
            case 'GetFreshAirType':
                return <GetFreshAirType reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></GetFreshAirType>;
            case 'SetFreshAirType':
                return <SetFreshAirType reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></SetFreshAirType>;
            case 'DeviceReset':
                return <DeviceReset reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></DeviceReset>;
            case 'DeviceHardReset':
                return <DeviceHardReset reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></DeviceHardReset>;
            case 'GetTWR':
                return <TripWiseReport reeferFormatter={self.props.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"vessel"} useremail={userEmail} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}
                    customerId={custId} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></TripWiseReport>;
        }
    }

    RenderContextMenuPopUp(popUpName: string, isCommands: boolean) {
        var reeferData = self.state.selectedItems;
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var filterSet: server.USP_UnitCurrentConditionUI_Model[];
        filterSet = reeferData;
        var filterParams = JSON.stringify(filterSet);
        var checkBoxInfo = this.state.VCCheckBoxInfo;
        if (isCommands) {
            if (reeferData != undefined && reeferData != null) {
                if (popUpName == "GetDLTraditional" || popUpName == "SchedulePreTrip") {
                    checkBoxInfo.disableVCOption = true;
                    checkBoxInfo.enableVCCheckBox = false;
                    checkBoxInfo.disableVCCheckBoxOption = true;
                    checkBoxInfo.disableVCDropDown = true;
                    checkBoxInfo.selectedVCData = null;
                    self.setState({ VCCheckBoxInfo: checkBoxInfo });
                    self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData, checkBoxInfo) });
                    $('#btnTrigger').click();
                }
                else {
                    $('#globalLoader').show();
                    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/CheckIsMsgFromVessel', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            var vesselid = data;
                            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetVesselInformation?customerID=' + custId;
                            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                            fetch(request)
                                .then(RCUtils.handleError)
                                .then(response => response.json() as Promise<server.VesselInformation[]>)
                                .then(result => {
                                    checkBoxInfo.dropDownVCData = result;
                                    if (result.length > 0) {
                                        if (vesselid == "-1") {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = false;
                                            checkBoxInfo.disableVCCheckBoxOption = true;
                                            checkBoxInfo.disableVCDropDown = true;
                                            checkBoxInfo.selectedVCData = null;
                                            checkBoxInfo.isVCMessage = true;
                                        }
                                        else if (vesselid == "0") {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = false;
                                            checkBoxInfo.disableVCCheckBoxOption = false;
                                            checkBoxInfo.disableVCDropDown = true;
                                            checkBoxInfo.selectedVCData = null;
                                            checkBoxInfo.isVCMessage = false;
                                        }
                                        else {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = true;
                                            checkBoxInfo.disableVCCheckBoxOption = false;
                                            checkBoxInfo.disableVCDropDown = false;
                                            checkBoxInfo.selectedVCData = checkBoxInfo.dropDownVCData.find(d => d.VesselId == parseInt(vesselid));
                                            checkBoxInfo.isVCMessage = true;
                                        }
                                    }
                                    else {
                                        checkBoxInfo.disableVCOption = true;
                                        checkBoxInfo.enableVCCheckBox = false;
                                        checkBoxInfo.disableVCCheckBoxOption = true;
                                        checkBoxInfo.disableVCDropDown = true;
                                        checkBoxInfo.selectedVCData = null;
                                    }
                                    self.setState({ VCCheckBoxInfo: checkBoxInfo });
                                    $('#globalLoader').hide();
                                    self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData) });
                                    $('#btnTrigger').click();
                                });
                        });
                }
            }
        }
        else {
            self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData) });
            $('#btnTrigger').click();
        }
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        self.setState({ VCCheckBoxInfo: VCInfo });
    }

    UpdateIsCommandIssued(IsCmdIssued: any) {
        self.setState({ IsCommandIssued: IsCmdIssued });
    }
    UpdatePrevSelectedItems(prevSelectedItems: any) {
        self.setState({ PrevSelectedItems: prevSelectedItems });
    }

    popUpGetPTIReport() {
        var reeferData = self.state.selectedItems;
        if (reeferData != undefined && reeferData != null) {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetPTRReport?containerID=' + reeferData[0].ReeferID;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    this.setState({ PTReport: result })
                    this.setState({ ReportReeferId: reeferData[0].ReeferID })
                    $('#globalLoader').hide();
                    if (this.state.PTReport == null || this.state.PTReport == '')
                        PopupWindow.showErrorMessage("Alert", "No pre-trip reports have been collected for this reefer. Execute the ‘Get Pre-Trip Results’ command to collect the latest available report.");
                    else {
                        this.setState({ modelTitle: 'Pre-Trip Report', popUpHtml: <div dangerouslySetInnerHTML={{ __html: this.state.PTReport }} /> });
                        $('#btnTriggerReport').click();
                    }
                });
        }
    }

    downloadPTReport() {
        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
            var blob = new Blob([this.state.PTReport], {
                type: "text/plain;charset=utf-8"
            });
            window.navigator.msSaveBlob(blob, 'PT_' + this.state.ReportReeferId + '.htm');
        } else {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.state.PTReport));
            element.setAttribute('download', 'PT_' + this.state.ReportReeferId + '.htm');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }

    printPTReport() {
        var divToPrint = document.getElementById("printData");
        var newWin = window.open("");
        newWin.document.write(divToPrint.innerHTML);
        newWin.document.close();
        newWin.print();
        newWin.close();
    }

    dragElement(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(elmnt.id)) {
            /* if present, the header is where you move the DIV from:*/
            document.getElementById(elmnt.id).onmousedown = dragMouseDown;
        } else {
            /* otherwise, move the DIV from anywhere inside the DIV:*/
            elmnt.onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
            e = e || window.event;
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            // set the element's new position:
            elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
            elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }

        function closeDragElement() {
            /* stop moving when mouse button is released:*/
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    groupRowInnerRenderer(params) {
        // self.clearGridRowSelection(params);        
        var fieldName = params.node.field;
        var fieldValue = params.node.key;
        //var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        //var columnDisplayName = colDef[0].colDef.headerName;
        var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;

        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() == "BatteryVoltage")
            return "*No " + columnDisplayName;

        if (fieldValue == "-NA-" || fieldValue == "null")
            return "*No " + columnDisplayName;

        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() != "HumiditySetpoint")
            return "OOR";

        //if (fieldName.toString() == "EventDTTM" || fieldName.toString() == "UnitEventDTTM" || fieldName.toString() == "PTRDateTime" || fieldName.toString() == "DataLoggerDtm" || fieldName.toString() == "ModifiedDTTM")
        //    return Formatters.dateTypeFormatterGrouping(fieldValue);

        switch (fieldName.toString().trim()) {
            case "RunState":
                return ReeferCellRenderer.RunStateFormatterGrouping(fieldValue);
            case "MASeverityLevel":
                return ReeferCellRenderer.StatusIndicatorALMFormatterGrouping(fieldValue);
            case "DevicePowerSourceCd":
                return ReeferCellRenderer.PowerStateFormatterGrouping(fieldValue);
            case "CCSeverityLevel":
                return ReeferCellRenderer.CargoCareFormatterGrouping(fieldValue);
            case "CustomerName":
                return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "*No Assigned To" : fieldValue;
            case "VesselCd":
                return fieldValue == "-NA-" ? "No VSL" : fieldValue;
            case "ReeferOEMTypeCd":
                return Formatters.OEMTypeFormatterGrouping(fieldValue);
            case "RSSI":
                return ReeferCellRenderer.RSSIFormatterGrouping(fieldValue);
            case "PTIState":
                return (fieldValue == "" || fieldValue == null) ? '-NA-' : fieldValue;
            case "DeviceConfig":
                return Formatters.GuestReeferModeGrouping(fieldValue);
            case "CommentExists":
                return ReeferCellRenderer.CommentExistsGrouping(fieldValue);
            case "PTResult":
                return ReeferCellRenderer.PTResultGrouping(fieldValue);
            case "AlarmsList":
                {
                    var DeviceType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                    }
                    return ReeferCellRenderer.AlarmDescriptionGroupingFormatter(fieldValue, DeviceType, self.props.reeferFormatter.AlarmMasterList);
                }
            case "Cargo4Temp":
            case "USDA3Temp":
            case "USDA2Temp":
            case "USDA1Temp":
            case "SetPoint":
            case "SupplyTemp1":
            case "SupplyTemp2":
            case "ReturnTemp1":
            case "AmbientTemp":
            case "ReturnTemp2":
            case "EvaporatorTemp":
            case "CompressorSuctionTemp":
            case "CompressorDischargeTemp":
            case "CondenserTemperature":
            case "DeviceTemp":
            case "SensorReturnTemp1":
            case "SensorSupplyTemp1":
                {
                    var DeviceType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                    }
                    return Formatters.TemperatureFormatterGrouping(fieldValue, fieldName, params, DeviceType);
                }

            case "TemperatureUnit":
                return Formatters.BookingTemperatureFormatterGrouping(fieldValue, fieldName, params);
            case "EventDTTM":
            case "UnitEventDTTM":
            case "PTRDateTime":
            case "DataLoggerDtm":
            case "ModifiedDTTM":

            case "GPSCoords":
                return Formatters.GPSCoordsFormatterGrouping(fieldValue, params);
            case "HumiditySetpoint":
                {
                var HumiditySetpointStatus;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        HumiditySetpointStatus = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HumiditySetpointStatus;
                    }
                    return Formatters.HumiditySetpointGrouping(fieldValue, HumiditySetpointStatus);
                }
            default:
                return fieldValue;

        }
    }


    onGridScroll(params: any) {
        //$(".context-menu").hide();
        //$("#contextmenu").hide();
    }

    refreshVesselData() {
        this.props.requestVesselData(vesselColumns);
    }

    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'OneDecimal',
                numberFormat: {
                    format: '0.0',
                },
                font: {
                    size: 12,
                }
            },
            {
                id: 'TwoDecimal',
                numberFormat: {
                    format: '0.00',
                },
                font: {
                    size: 12,
                }
            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
        ];
        return <div>
            <div className="row">
                <div className='col-md-12'>
                    <div className="innerpages-heading">
                        Vessel Status
                        </div>
                    <div>
                        <VesselSearch vesselFilters={this.props.searchFilters} vesselData={this.state.vesselData} refreshVesselData={this.refreshVesselData.bind(this)} bindingVesselStatusGrid={this.bindingVesselStatusGrid.bind(this)}></VesselSearch>
                    </div>
                </div>
            </div>
            <div>
                <GridToolBarControl refreshGrid={self.refreshStatusGrid.bind(this)} gridData={this.props.vesselStatus} colDefs={this.props.columnDefs}
                    isIncludeRowGroup={this.state.gridApiParams.gridOptionsWrapper == undefined
                        && this.state.gridApiParams.gridOptionsWrapper == null ? false :
                        this.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false}
                    gridApiParams={this.state.gridApiParams} parentchild={"P"} formName={"VesselStatus"} />
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="ag-theme-fresh containerstyle_grid" id='VesselStatusGrid'>
                        <AgGridReact
                            columnDefs={vesselColumns}
                            rowData={this.state.gridData}
                            onGridReady={this.onGridReady}
                            animateRows={true}
                            rowGroupPanelShow={this.state.rowGroupPanelShow}
                            autoGroupColumnDef={this.state.autoGroupColumnDef}
                            suppressDragLeaveHidesColumns={true}
                            suppressMakeColumnVisibleAfterUnGroup={true}
                            excelStyles={excelStyles}
                            groupRowRendererParams={groupRowRendererParams}
                            //groupRowInnerRenderer={this.groupRowInnerRenderer}
                            defaultGroupOrderComparator={
                                function (nodeA, nodeB) {
                                    var AnodeIsNumber = Number(nodeA.key);
                                    var BnodeIsNumber = Number(nodeB.key);
                                    var AnodeIsString = String(nodeA.key);
                                    var BnodeIsString = String(nodeB.key);

                                    if (!isNaN(AnodeIsNumber) && !isNaN(BnodeIsNumber)) {
                                        return AnodeIsNumber - BnodeIsNumber;
                                    } else {
                                        return AnodeIsString.localeCompare(BnodeIsString);
                                    }
                                }
                            }
                            groupDisplayType='groupRows'
                            enableRangeSelection={true}
                            accentedSort={true}
                            pagination={true}
                            rowSelection={'multiple'}
                            rowDeselection={true}
                            onSelectionChanged={this.onSelectionChanged}
                            allowContextMenuWithControlKey={true}
                            getContextMenuItems={this.getVesselContextMenuItems}
                            paginationPageSize={this.state.pageSize}
                            onBodyScroll={this.onGridScroll}>
                        </AgGridReact>
                    </div>
                    <div className='pageSize'>
                        <span className='pageSize-lable'>Page Size:</span>
                        <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="contextMenuModel" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.modelTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>                            
                        </div>
                        <div className="modal-body">
                            {this.state.popUpHtml}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="contextMenuModelReport" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" id="contextMenuModelHeader">
                            <h5 className="modal-title">{this.state.modelTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                           
                        </div>
                        <div className="modal-body ptr-report pb-3">
                            <div className='aggrid-icons-bg'>
                                <div className="btn-group aggrid-icons">
                                    <button type="button" id="hidePopUpBtn" title='Download' className="btn btn-outline-secondary" onClick={this.downloadPTReport.bind(this)}><span className='fa fa-download'></span></button>
                                    <button type="button" id="hidePopUpBtn" title='Print' className="btn btn-outline-secondary" onClick={this.printPTReport.bind(this)}><span className='fa fa-print'></span></button>
                                </div>
                            </div>
                            {this.state.popUpHtml}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerReport" data-bs-toggle="modal" className='hidden' data-bs-target="#contextMenuModelReport" />
            <div className='hidden ptr-report' id="printData"><div dangerouslySetInnerHTML={{ __html: this.state.PTReport }} />
            </div>
            <div className='row' id='contextmenu'>
                <button id="btnTrigger" data-bs-toggle="modal" className='hidden' data-bs-target="#contextMenuModel" />
                <div className='context-menu'>
                    <ul>
                        <li id="liMapRequiresRight" className={UserRights.checkVisibility('14')} onClick={this.vesselContextMenuClick.bind(this, "Map")}>Map</li>
                        <li id="liDetailsRequiresRight" className={UserRights.checkVisibility('34')} onClick={this.vesselContextMenuClick.bind(this, "Details")}>Current Details</li>
                        <li id="liHistoryRequiresRight" className={UserRights.checkVisibility('15')} onClick={this.vesselContextMenuClick.bind(this, "History")}>History</li>
                        <li id="liCommandStatusRequiresRight" className={UserRights.checkVisibility('3')} onClick={this.vesselContextMenuClick.bind(this, "CommandStatus")}>Command History</li>
                        {
                            //<li id="liVesselTasksRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('74, 75')}>
                            //    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Vessel Tasks</a>
                            //    <ul className='dropdown-menu'>
                            //        <li id="liAssignVSLRequiresRight" className={UserRights.checkVisibility('74')} onClick={this.manageVessel.bind(this, true)}>Assign To Vessel</li>
                            //        <li id="liUnassignVSLRequiresRight" className={UserRights.checkVisibility('75')} onClick={this.manageVessel.bind(this, false)}>UnAssign from Vessel</li>
                            //    </ul>
                            //</li>
                        }
                        <li id="liCargoCareTasksRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('76, 77')}>
                            <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>CargoCare Tasks</a>
                            <ul className='dropdown-menu'>
                                <li id="liAssignCCRequiresRight" className={UserRights.checkVisibility('76')} onClick={this.assignCargoCare.bind(this)}>Assign to CargoCare</li>
                                <li id="liUnassignCCRequiresRight" className={UserRights.checkVisibility('77')} onClick={this.unAssignCaregoCare.bind(this)}>Unassign from CargoCare</li>
                                <li id="liClearSetPoint" onClick={this.clearSetPoint.bind(this)}>Clear Set Point</li>
                            </ul>
                        </li>
                        <li id="liCommandsRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('18, 19, 20, 21, 22, 23, 26, 27, 24, 25, 28, 29, 30, 31, 32, 33, 80, 81, 83, 84, 85, 89, 90, 92, 103, 104, 106, 108, 109, 111, 112, 113, 114, 115, 116, 118, 122, 123, 125, 126, 145, 150')}>
                            <a className='dropdown-toggle' id="commandsubMenu" data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Commands</a>
                            <ul className='dropdown-menu top-10'>
                                <li className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('26, 81, 145, 150')}>
                                    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Reporting</a>
                                    <ul className='dropdown-menu'>
                                        <li id="liPingRequiresRight" className={UserRights.checkVisibility('26')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpPing.bind(this)}>Ping / Report</li>
                                        <li id="liReportingIntervalRequiresRight" className={UserRights.checkVisibility('81')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpChangeReporting.bind(this)}>Set Reporting Interval</li>
                                        <li id="liDeviceResetRequiresRight" className={UserRights.checkVisibility('145')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpDeviceReset.bind(this)}>Device Reset</li>
                                        <li id="liDeviceHardResetRequiresRight" className={UserRights.checkVisibility('150')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpDeviceHardReset.bind(this)}>Device Reset To Defaults</li>
                                    </ul>
                                </li>
                                <li className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('23, 27, 24, 25, 28, 92, 108')}>
                                    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Reefer Settings</a>
                                    <ul className='dropdown-menu'>
                                        <li className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('23, 27, 24, 25')}>
                                            <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Change Setpoints</a>
                                            <ul className='dropdown-menu'>
                                                <li id="liSetpointRequiresRight" className={UserRights.checkVisibility('23')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpChangeTempSetPoint.bind(this)}>Temperature</li>
                                                <li id="liHumidityRequiresRight" className={UserRights.checkVisibility('27')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpHumiditySetPoint.bind(this)}>Humidity</li>
                                                <li id="liO2SetPointRequiresRight" className={UserRights.checkVisibility('24')} onClick={this.popUpO2SetPoint.bind(this)}>O2</li>
                                                <li id="liCO2SetPointRequiresRight" className={UserRights.checkVisibility('25')} onClick={this.popUpCo2SetPoint.bind(this)}>CO2</li>
                                            </ul>
                                        </li>
                                        <li id="liClockRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('92, 108')}>
                                            <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Clock</a>
                                            <ul className='dropdown-menu'>
                                                <li id="liSyncReeferClockRequiresRight" className={UserRights.checkVisibility('92')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpSyncReeferClock.bind(this)}>Sync to Device</li>
                                                <li id="lichangereeferclocksettingRequiresRight" className={UserRights.checkVisibility('108')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpChangeReeferClockSyncSetting.bind(this)}>Clock Sync Settings</li>
                                            </ul>
                                        </li>
                                        <li id="liUpdateContainerIdRequiresRight" className={UserRights.checkVisibility('28')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpChangeReeferId.bind(this)}>Change Reefer ID</li>
                                        <li id="liControlledAtmosphereRight" className={UserRights.checkVisibility('139')} onClick={this.popUpControlledAtmosphere.bind(this)}>Controlled Atmosphere</li>
                                    </ul>
                                </li>
                                <li id="liReeferDataLogRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('29, 31, 32, 80')}>
                                    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Reefer Data Log</a>
                                    <ul className='dropdown-menu'>
                                        <li id="liTraditionalDownloadRequiresRight" className={UserRights.checkVisibility('31')} onClick={this.popUpDLTraditional.bind(this)}>Get Data Log</li>
                                        <li id="liUpdateDatalogRequiresRight" className={UserRights.checkVisibility('29')} onClick={this.popUpChangeDatalog.bind(this)}>Set Data Log Interval</li>
                                        <li id="liManagerealTimedSettingsRequiresRight" className={UserRights.checkVisibilityMultiple('32, 80')}>Real-Time Retrieval Settings</li>
                                    </ul>
                                </li>
                                <li className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('18, 19, 20, 21, 30, 106, 206')}>
                                    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false' onMouseOver={this.setCommandText.bind(this, this.state.selectedItems.map(x => x.ReeferOEMTypeCd))} >Reefer Pre-Trip</a>
                                    <ul className='dropdown-menu'>
                                        <li id="liPreTripRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('18, 19, 20')}>
                                            <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Start Pre-Trip</a>
                                            <ul className='dropdown-menu'>
                                                <li id="liFullPreTripRequiresRight" className={UserRights.checkVisibility('18')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpPreTripFull.bind(this)}>{this.state.fullPreTripCommandText}</li>
                                                <li id="liStartPreTripShortRequiresRight" className={UserRights.checkVisibility('19')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpPreTripShort.bind(this)}>{this.state.shortPreTripCommandText} </li>
                                                <li id="liStartPreTripFtRequiresRight" className={UserRights.checkVisibility('20')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpFunctionTest.bind(this)}>{this.state.funcPreTripCommandText}</li>
                                                <li id="liStartPreTripChilledRequiresRight" className={UserRights.checkVisibility('140')} onClick={this.popUpChangeToChilled.bind(this)}>Chilled</li>
                                                <li id="liStartPreTripFrozenRequiresRight" className={UserRights.checkVisibility('141')} onClick={this.popUpChangeToFrozen.bind(this)}>Frozen</li>
                                                <li id="liStartPreTripCARequriesRight" className={UserRights.checkVisibility('142')} onClick={this.popUpChangeToCA.bind(this)}>CA</li>
                                                <li id="liStartCAFullPTIRequriesRight" className={UserRights.checkVisibility('143')} onClick={this.popUpChangeToCAFullPTI.bind(this)}>CA Full</li>
                                                <li id="liStartCAFuntionTestRequriesRight" className={UserRights.checkVisibility('144')} onClick={this.popUpChangeToCAFunctionTest.bind(this)}>CA Function Test</li>
                                                <li id="liStartPreTripChilledandCARequiresRight" className={UserRights.checkVisibility('148')} onClick={this.popUpChangeToChilledandCA.bind(this)}>Chilled and CA</li>
                                            </ul>
                                        </li>
                                        <li id="liStopPreTripRequiresRight" className={UserRights.checkVisibility('21')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpStopPTI.bind(this)}>Stop Pre-Trip</li>
                                        <li id="liScheduledPreTripRequiresRight" className={UserRights.checkVisibility('106')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpSchedulePTI.bind(this)}>Scheduled Pre-Trip</li>
                                        <li id="lilastpretripresultRequiresRight" className={UserRights.checkVisibility('30')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpGetPTI.bind(this)}>Get Pre-Trip Results</li>
                                        <li id="lilastpretripreportRequiresRight" className={UserRights.checkVisibility('30')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpGetPTIReport.bind(this)}>Show Pre-Trip Results</li>
                                        <li id="litripwiseReportRequiresRight" className={UserRights.checkVisibility('206')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpGetTWR.bind(this)}>Get TripWise Report</li>
                                    </ul>
                                </li>
                                <li id="liUploadFirmwareRequiresRight" className={UserRights.checkVisibility('33')}>Distribute/Install Reefer Software</li>
                                <li id="liRebootReeferController" data-bs-toggle="modal" onClick={this.popUpRebootReefer.bind(this)}>Reboot Reefer Controller</li>
                                <li id="liQueryReeferInventoryRequiresRight" className={UserRights.checkVisibilityMultiple('83, 84, 85')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpQueryReefer.bind(this)}>Query Reefer Inventory</li>
                                <li id="liReeferModelConfiguration" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('89, 90')}>
                                    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Reefer Model Configuration</a>
                                    <ul className='dropdown-menu'>
                                        <li id="liUpdateModelConfigurationRequiresRight" className={UserRights.checkVisibility('89')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpUpdateModelConfig.bind(this)}>Update</li>
                                        <li id="liVerifyModelValidityRequiresRight" className={UserRights.checkVisibility('90')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpVerifyModelValidity.bind(this)}>Verify</li>
                                    </ul>
                                </li>
                                <li id="liDefrostRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('103, 104')}>
                                    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Defrost</a>
                                    <ul className='dropdown-menu'>
                                        <li id="liStartDefrostRequiresRight" className={UserRights.checkVisibility('103')} onClick={this.popUpStartDeforst.bind(this)}>Start Defrost</li>
                                        <li id="liChangeDefrostIntervalRequiresRight" className={UserRights.checkVisibility('104')} onClick={this.popUpChangeDeforstInterval.bind(this)}>Chg.Defrost Interval</li>
                                    </ul>
                                </li>
                                <li id="liMSCRequiresRight" className={UserRights.checkVisibility('123')} onClick={this.popUpMSC.bind(this)}>Multiple Setpoints</li>
                                <li id="liACTRequiresRight" className={UserRights.checkVisibility('122')} onClick={this.popUpACT.bind(this)}>Automatic Cold Treatment</li>
                                {customerTypeCd == "SO" ? <div>
                                    <li id="liassignGuestreeferRequiresRight" className={UserRights.checkVisibilityMultiple('112, 113, 114, 115, 116')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpGuestReeferConfigCmd.bind(this)}>Guest Reefer configuration</li>
                                    <li id="liZigbeesettingsRequiresRight" className={UserRights.checkVisibility('118')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpZigbeeSettings.bind(this)}>Change Zigbee Config Settings</li>
                                    <li id="liassignpanidRequiresRight" className={UserRights.checkVisibility('109')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpAssignPanId.bind(this)}>Assign PAN Id</li>
                                    <li id="liAutoConfigurationRequiresRight" className={UserRights.checkVisibility('110')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popAutoConfiguration.bind(this)}>Device Configuration</li>
                                    <li id="liAssetConfigurationRequiresRight" className={UserRights.checkVisibility('121')} data-bs-toggle="modal" data-backdrop="static" onClick={this.popAssetConfiguration.bind(this)}>Asset Configuration</li>
                                </div> : <div></div>}
                                <li id="liFreshAirTypeRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('125, 126')}>
                                    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Fresh Air Type</a>
                                    <ul className='dropdown-menu top-185'>
                                        <li id="liGetFreshAirTypeRequiresRight" className={UserRights.checkVisibility('125')} onClick={this.popUpGetFreshAirType.bind(this)}>Get - Fresh Air Type</li>
                                        <li id="liSetFreshAirTypeRequiresRight" className={UserRights.checkVisibility('126')} onClick={this.popUpSetFreshAirType.bind(this)}>Set - Fresh Air Type</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        {
                            //<li id="liThirdPartyAccessRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('40, 82')}>
                            //    <a className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Third Party Access</a>
                            //    <ul className='dropdown-menu'>
                            //        <li id="liAssignToCustomerRequiresRight" className={UserRights.checkVisibility('40')} data-backdrop="static" data-bs-toggle="modal" onClick={this.popUpAssignToCustomer.bind(this)}>Assign to Customer</li>
                            //        <li id="liUnassignFromCustomerRequiresRight" className={UserRights.checkVisibility('82')} data-backdrop="static" data-bs-toggle="modal" onClick={this.popUpUnAssignFromCustomer.bind(this)}>Unassign from Customer</li>
                            //    </ul>
                            //</li>
                        }
                        <li onClick={this.exportToExcel.bind(this)}>Export to Excel</li>
                        <li data-bs-toggle="modal" data-backdrop="static" onClick={this.popUpSendEmail}>Send Email</li>
                    </ul>
                </div>
            </div>
        </div>;
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.userDetails, ...state.vesselStatus }), // Selects which state properties are merged into the component's props
    VesselStatusState.actionCreators,
)(VesselStatus as any);
